<script>
import api from "@/axios";
import Loader from "../components/loader";
import Layout from '../../layouts/main'
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import moment from "moment/moment";
import Swal from "sweetalert2";
import xmlFormat from 'xml-formatter';
import Multiselect from "@vueform/multiselect";
//import router from "@/router";

//teste
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Pedido",
    meta: [{name: "description", content: appConfig.description}]
  },
  components: {Layout, PageHeader, Loader, Multiselect},
  data() {
    return {
      dtListPesqTransp: [],
      showModalEditaTransp: false,
      showModalEditaVlrf: false,
      listaTransportadoras: [],
      transpselecionada: null,
      transpDatas: {},
      transpData: {},
      TranspSelecionado: null,
      cotaFreteListData: {},
      submittedVolume: false,
      cotafrt: {},
      cotaFrtVolume: {},
      cotaFrtVolumes: [],
      showModalVolume: false,
      opcaoadditem: false,
      modalHelpVbc: false,
      justificativaCanc: '',
      justificativaCorr: '',
      showModalCancFocusNfe: false,
      showModalCorrFocusNfe: false,
      tipoConsultaFocusNFe: false,
      modalConsultaSimplificada: false,
      retornoConsultaFocusNFe: {},
      modalRetornoEnvioFocusnfe: false,
      statusFocusnfe: '',
      loadingCotarFrete: false,
      showModalCotarFrete: false,
      modalErros: false,
      nota_ide: {},
      nota_emit: {},
      nota_dest: {},
      nota_item: {},
      nota_total: {},
      nota_pag: {},
      nota_infadic: {},
      showEspelhoNota: false,
      showModalMovCompra: false,
      dtListPesqCompra: null,
      ordemcompra: '',
      //*** Fim implementação focusnfe => Pablo */

      envCliEnviarXml: 'A',
      envDanfeEnviarXml: 'A',
      emailAdicEnviarXml: '',
      showModalEnviarXML: false,
      userLogged: null,
      financeirosData: {},
      loadingCondPgto: false,
      loadingFinanc: false,
      loadingFormaPgto: false,
      ultPedsData: null,
      dtListPesqCondPgto: null,
      dtListPesqFormaPgto: null,
      showModalCondPgto: false,
      showModalFormaPgto: false,
      notaLotesData: null,
      mediaJsonPedEnvio: null,
      mediaJsonPedRet: null,
      mediaJsonPed: {},
      mediaJsonNota: {},
      mediaJsonSep: {},
      mediaJsonEmb: {},
      mediaJsonCanc: {},
      mediaJsonConfEmb: {},
      showModalMediaJson: false,
      showModalXML: false,
      xmlContent: '1,2,3',
      loadingXML: false,
      loadingPedido: true,
      pedidoData: {
        condpgto: null,
        formapgto: null,
        banco: null,
        banco_id: null,
        consutil: false,
      },
      empresaData: {},
      contaData: {},
      clienteData: {},
      pedItensData: {},
      condPgtoData: {},
      formaPgtoData: {},
      pedLogsData: {},
      mediasData: {},
      idData: 0,
      title: "Detalhes Pedido",
      items: [
        {
          text: "Pedidos",
          href: "/pedidos/list"
        },
        {
          text: "Detalhes Pedido",
          active: true
        }
      ],

      flagEmprParamItem: false,
      pedItemData: {},
      showModalPedItem: false,
      messageValidacaoItem: "",
      dtListLotes: [],
      dtlistPesqPedItem: [],
      loadingPedItem: false,
      submitPedItem: false,

      showModalNatureza: false,
      dtlistPesqNatureza: [],
      naturezaData: {},
      showModalObs: false,
      loadingPedTipo: false,

      dtListPesqConta: [],
      showModalFinanceiroData: false,
      orctoData: {},
      flagEmprParamFinancFrete: false,
      dtListWmsOsVolumes: [],
      showModalDadosVolumes: false,

      orcamentosAgregados: [],
      somaPesoBruto: null,
      cubagemTotal: null,

      volumesquantidade: 0,
    };
  },

  computed: {

    valorTotalCalculadoDosItens() {
      if (!this.pedItensData || this.pedItensData.length === 0) {
        return 0;
      }
      const total = this.pedItensData.reduce((acc, item) => {
        return acc + parseFloat(item.vlrtotalliq || 0);
      }, 0);
      return total;
    },
  },

  mounted() {

    this.userLogged = JSON.parse(localStorage.getItem('user'))
    this.carregarDados()
  },

  methods: {

    pesqTransp(evt) {
      console.log("pesqTransp");
      console.log(evt);
      let query = evt;
      console.log(query.length);
      if (query.length > 1) {
        this.loadingTransp = true;
        // this.pedidoData.transp = "";
        api
          .get(`${getBaseUrl()}api/transpesq`, {
            params: { q: query },
          })
          .then((res) => {
            console.log("then axios");
            console.log(res.data);
            //console.log(res.data.length)
            this.dtListPesqTransp = res.data;
            console.log(this.dtListPesqTransp)
          });
      }
    },

    escolheuTransp() {
      console.log("escolheuTransp");
      this.loadingTransp = true;
      console.log(this.TranspSelecionado);
      api
        .get(`${getBaseUrl()}api/clicod`, {
          params: { coddata: this.TranspSelecionado },
        })
        .then((res) => {
          console.log("then axios_escolheu_transp");
          console.log(res.data);
          this.transpData = res.data[0];
          this.loadingTransp = false;
        });
    },

    confirmaEditvlrfrt() {
      this.showModalEditaVlrf = false
      this.salvarPedido()
    },

    confirmaEditTransp() {
      this.showModalEditaTransp = false
      this.pedidoData.transp = this.transpData.cnpj

      this.salvarPedido()
    },

    buscaDadosVolumes(){
      console.log('buscaDadosVolumes')

      api.get(`${getBaseUrl()}api/getdadoswmsosvolume`, {
        params: {
          iddata: this.idData,
          tabela: 'pedido'
        }
      }).then((res) => {
        console.log('then axios get getdadoswmsosvolume:')
        console.log(res.data)
        console.log(JSON.stringify(res.data))

        this.volumesquantidade = res.data.quantidadeVolumes
        this.somaPesoBruto = res.data.somaPesoBruto || 0
        // console.log(this.somaPesoBruto)
        this.dtListWmsOsVolumes = res.data?.volumes ?? []
        if(this.dtListWmsOsVolumes.length > 0){
          this.showModalDadosVolumes = true
        }
      })
    },

    buscaDadosPesoVolumes(){
      console.log('buscaDadosPesoVolumes')

      api.get(`${getBaseUrl()}api/getdadoswmsosvolume`, {
        params: {
          iddata: this.idData,
          tabela: 'pedido'
        }
      }).then((res) => {
        console.log('then axios get getdadoswmsosvolume:')
        // console.log(JSON.stringify(res.data))

        this.volumesquantidade = res.data.quantidadeVolumes
        this.somaPesoBruto = res.data.somaPesoBruto || 0
        // console.log(this.somaPesoBruto)
      })
    },

    somaPesoPedItens(){
      if (!this.pedItensData?.length) {
        this.pedidoData.pesoliq = 0
        return
      }

      const total = this.pedItensData.reduce((soma, item) => {
        const peso = parseFloat(item.peso) || 0
        return soma + peso
      }, 0)

      console.log('Peso líquido total calculado:', total)
      this.pedidoData.pesoliq = total
    },

    gerarFinanceiro() {
      let gerarParcelaFrete = false
      if(this.flagEmprParamFinancFrete){
        Swal.fire({
          position: "center",
          icon: "question",
          title: "Gerar parcela de frete?",
          text: "Vencimento da primeira parcela.",
          showConfirmButton: true,
          showCancelButton: true,
          confirmButtonText: "Gerar",
          cancelButtonText: "Não gerar",
          showDenyButton: true,
          denyButtonText: "Fechar"
        }).then(check => {
          console.log("check: " + JSON.stringify(check))

          if(check.isDenied){
            return
          }

          if(check.isConfirmed){
            gerarParcelaFrete = true
          }

          this.disparoGerarFinanceiro(gerarParcelaFrete)
        })
      } else {
        this.disparoGerarFinanceiro(gerarParcelaFrete)
      }
    },

    disparoGerarFinanceiro(gerarParcelaFrete){
      console.log('disparoGerarFinanceiro')

      api.get(`${getBaseUrl()}api/criarfinanped`, {
        params: {
          iddata: this.idData,
          gerarParcelaFrete: gerarParcelaFrete
        }
      }).then((res) => {
        console.log('then axios get criarfinanped:')
        console.log(res.data)
        //console.log(JSON.stringify(res.data))

        if (res.data.success) {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: res.data.message,
            showConfirmButton: false,
            timer: 2500
          })

        }else{
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: res.data.message,
            showConfirmButton: false,
            timer: 2500
          })
        }
        this.carregarDados()
      })
    },

    carregarDados() {
      console.log('carregarDados')

      console.log('mounted pedido-detalhe_0')
      let rota = this.$route.path
      // console.log(rota)
      let ultimaBarra = rota.lastIndexOf('/')
      if (ultimaBarra) {
        this.idData = parseInt(rota.substring(ultimaBarra + 1))
      }
      console.log('this.idData')
      console.log(this.idData)

      api.get(`${getBaseUrl()}api/pedido`, {
        params: {iddata: this.idData}
      }).then((res) => {
        console.log('then axios get pedido:')
        console.log(res.data)
        //console.log(JSON.stringify(res.data))

        this.pedidoData = res.data[0]
        this.volumesquantidade = this.pedidoData.qtdvol
        this.clienteData = res.data[1]
        this.pedItensData = res.data[2]
        this.condPgtoData = res.data[3]
        this.pedLogsData = res.data[4]
        this.mediasData = res.data[5]
        this.transpData = res.data[10]
        this.flagEmprParamItem = res.data[11]
        this.naturezaData = res.data[12]
        this.nota_item = res.data[13]
        this.nota_ide = res.data[14]
        this.opcaoadditem = res.data[17]
        this.empresaData = res.data[18]

        this.somaPesoPedItens()

        if(this.pedidoData.dtfatura !== null){
          this.pedidoData.dtfatura = moment(this.pedidoData.dtfatura)
        }

        if (this.pedItensData.length > 0) {
          this.pedItensData.forEach((value) => {
            if (value.imgs) {
              let imgTrat = value.imgs.split(',')
              value.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`
            }

          });
        }

        if (res.data[6].length > 0) {
          res.data[6].forEach((value) => {
            // console.log(value)
            if (value.rota === 'CORPEM_ERP_DOC_SAI') {
              this.mediaJsonPed = value
            } else if (value.rota === 'CORPEM_ERP_CONF_NF') {
              this.mediaJsonNota = value
            } else if (value.rota === 'CORPEM_WMS_CONF_SEP') {
              this.mediaJsonSep = value
            } else if (value.rota === 'CORPEM_WMS_DOC_EMB') {
              this.mediaJsonEmb = value
            } else if (value.rota === 'CORPEM_ERP_CANC_PED') {
              this.mediaJsonCanc = value
            } else if (value.rota === 'CORPEM_WMS_CONF_EMB') {
              this.mediaJsonConfEmb = value
            }
          });
        }

        this.notaLotesData = res.data[7]
        //this.notaLotesData.forEach((value) => {
          //console.log('value lote sefaz')
          //console.log(value)
        //})

        if(this.condPgtoData && this.condPgtoData.id){
          this.dtListPesqCondPgto = [
            {
              id: this.condPgtoData.id,
              codigo: this.condPgtoData.codigo,
              descricao: this.condPgtoData.descricao,
            }
          ]
        }


        this.formaPgtoData = res.data[8]

        if(this.formaPgtoData && this.formaPgtoData.id){
          this.dtListPesqFormaPgto = [
            {
              id: this.formaPgtoData.id,
              codigo: this.formaPgtoData.codigo,
              descricao: this.formaPgtoData.descricao,
            }
          ]
        }

        this.contaData = res.data[15]

        if (res.data[16]) {
          this.orctoData = res.data[16]
        }


        if (res.data.orcamentosAgregados && res.data.orcamentosAgregados.length > 0) {
          this.orcamentosAgregadosData = res.data.orcamentosAgregados
          console.log('Sucesso: Lista de orçamentos agregados carregada (' + this.orcamentosAgregadosData.length + ' itens).')
        } else {
          this.orcamentosAgregadosData = []
          console.log('Aviso: Nenhum orçamento agregado extra encontrado.')
        }

        this.cubagemTotal = res.data[21]

        if(this.contaData && this.contaData.id){
          this.dtListPesqConta = [
            {
              id: this.contaData.id,
              banco: this.contaData.banco,
              descricao: this.contaData.descricao,
            }
          ]
        }

        this.financeirosData = res.data[9]
        this.TranspSelecionado = this.transpData?.codigo ?? null

        if(this.financeirosData && this.financeirosData.emissao) {
          this.financeirosData.emissao_fmt = moment(this.financeirosData.emissao).format('DD/MM/YYYY')
        }

        if(this.pedidoData && this.pedidoData.consutil == null) {
          this.pedidoData.consutil = false
        }

        if(res.data[19]){
          this.flagEmprParamFinancFrete = true
        }

        if(res.data[20]){
          this.cotaFreteListData = res.data[20]['SDT_WSRetorno']['Resultados']
        }

        this.idData = this.pedidoData.id
        this.title = `${this.pedidoData.empresa} - Detalhes Pedido ${this.idData} (${this.pedidoData.codigo}) ${this.clienteData.nome}`
        this.loadingPedido = false
      });
      this.buscaDadosPesoVolumes()
    },

    salvarPedido() {
      console.log('salvarPedido')

      api.post(`${getBaseUrl()}api/pedido`, {
        pedidoData: this.pedidoData
      }).then((res) => {
        console.log('then axios')
        console.log(res)

        this.loadingList = false

        let success = res.data.success

        if (success) {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
        }else{
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: res.data.error,
            showConfirmButton: false,
            timer: 2500
          })
        }



      }).catch((err) => {
        console.log('erro axios')
        // console.log(err)
        // console.log(err.response)
        // console.log(err.response.data.errors)
        let erros = err.response.data.errors
        console.log(erros)
        console.log(typeof erros)
        let listaErros = []
        Object.keys(erros).forEach(key => {
          console.log(key, erros[key]);
          listaErros.push({
            'titulo': key,
            'mensagem': erros[key]
          })
        });
        this.errosValid = listaErros

      })
    },

    escolheuNatureza(){
      console.log('escolheuNatureza')

      if (Array.isArray(this.dtlistPesqNatureza) && this.dtlistPesqNatureza.length > 0) {
        this.naturezaData = this.dtlistPesqNatureza.find((natureza) => {
          if (natureza.id === this.pedidoData.tipo) {
            console.log('natureza selected:')
            console.log(natureza)

            return natureza
          }
        })

        console.log('naturezaData:')
        console.log(this.naturezaData)

        this.loadingPedTipo = false
        this.pedidoData.tipo = this.naturezaData.id
        console.log('pedidoData.tipo: ' + this.pedidoData.tipo)
        if (this.pedidoData.tipo !== null && this.pedidoData.tipo !== "") {
          //this.showModalNatureza = false
        }

        this.salvarPedido()
      }
    },

    pesqNatureza(evt) {
      console.log('pesqNatureza')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1) {
        this.loadingPedTipo = true
        this.pedidoData.tipo = ''
        api.get(`${getBaseUrl()}api/naturpesq`, {
          params: { q: query, t: 'S', f: this.pedidoData.empresa }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtlistPesqNatureza = res.data
        })
      }
    },

    redirecionarNatureza(){
      console.log('redirect to natureza')

      let url = this.$router.resolve(`/natureza/editar/${this.naturezaData.id}`)
      window.open(url.href, '_blank')
    },

    downloadEspelhoPedido(){
      this.updating = true;
      api
        .get(`${getBaseUrl()}api/pedpdf`, {
          responseType: "blob",
          params: { iddata: this.idData },
        })
        .then((res) => {
          var fileURL = window.URL.createObjectURL(new Blob([res.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute(
            "download",
            "Pedido " + this.idData + ".pdf"
          );
          document.body.appendChild(fileLink);
          fileLink.click();
          this.updating = false;
        });
    },

    editarFinanceiro() {
      console.log('editarFinanceiro')

      this.showModalFinanceiroData = true;
    },

    confirmarFinanceiro() {
      console.log('confirmarFinanceiro')

      const pedidoData = this.pedidoData

      this.pedidoData.condpgto = pedidoData.condpgto
      this.pedidoData.formapgto = pedidoData.formapgto
      this.pedidoData.banco_id = pedidoData.banco_id
      this.pedidoData.consutil = pedidoData.consutil

      this.showModalFinanceiroData = false

      this.salvarPedido()
    },

    pesqLotes(evt){
      //console.log('pesqLotes')
      //console.log('evt')
      //console.log(evt)

      let query = evt
      //console.log(query.length)

      if (query.length > 1){
        api.get(`${getBaseUrl()}api/pesqlotes`, {
          params: {
            q: query,
            produto_id: this.pedItemData['produto_id'],
            qtd: this.pedItemData['qtd']
          }
        }).then((res) => {
          console.log('then axios pesqlotes')
          console.log(res.data)

          this.dtListLotes = res.data
        })
      }
    },

    novoProduto(){
      this.pedItemData = {}
      this.showModalPedItem = true
    },

    pesqPedItem(evt) {
      //console.log('pesqPedItem')
      //console.log(evt)
      let query = evt
      //console.log(query.length)
      if (query.length > 1) {
        this.dtlistPesqPedItem = null
        this.loadingPedItem = true
        api.get(`${getBaseUrl()}api/prodpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios search items:')
          console.log(res.data)
          this.dtlistPesqPedItem = res.data

          this.dtlistPesqPedItem.forEach((value) => {
            if (value.imgs) {
              let imgTrat = value.imgs.split(',')
              value.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`
            }
            value['descrcodigo'] = value['codigo'] + ' ' + value['descricao'] + ' ' + value['codbarra']
          });

        })
      }
    },

    escolheuPedItem() {
      this.loadingPedItem = true
      api.get(`${getBaseUrl()}api/prodcod`, {
        params: { coddata: this.pedItemData.produto }
      }).then((res) => {
        console.log('then new item')
        console.log(res.data)

        let imgTrat = ''
        if (res.data[0]['imgs']) {
          // img1 = res.data[0]['imgs']
          imgTrat = res.data[0]['imgs'].split(',')
          // this.produtoData.imgSTrat = `${getBaseUrl()}/uploads/imgprods/peq/${imgTrat[0]}`
        }

        this.pedItemData = {
          orcamento_id: this.idData,
          produto_id: res.data[0]['id'],
          produto: res.data[0]['codigo'],
          descprod: res.data[0]['descricao'],
          und: res.data[0]['unidade'],
          vlrunitliq: res.data[0]['preco'],
          vlrunitbrt: res.data[0]['preco'],
          vlrtotalliq: res.data[0]['preco'],
          vlrtotalbrt: res.data[0]['preco'],
          saldo: res.data[0]['saldo'],
          pesobrtun: res.data[0]['pesobrt'],
          pesobrttot: res.data[0]['pesobrt'],
          pesoliqun: res.data[0]['pesoliq'],
          pesoliqtot: res.data[0]['pesoliq'],
          cubunt: res.data[0]['compr'] * res.data[0]['larg'] * res.data[0]['altu'],
          cubtot: res.data[0]['compr'] * res.data[0]['larg'] * res.data[0]['altu'],

          imgSTrat: `${getBaseUrl()}/uploads/imgprods/peq/${imgTrat[0]}`,
          qtd: 1
        }

        console.log(`pedItemData: ${this.pedItemData}`)
        this.ultPedsData = res.data[1]

        this.loadingPedItem = false
      })
    },

    confPedItem() {
      this.v$.$touch()
      this.submitOrctoItem = true

      if (this.v$.$invalid) {
        return;
      } else {
        console.log('item is valid')
        this.loadingPedItem = true

        console.log(`item: ${this.pedItemData}`)

        api.post(`${getBaseUrl()}api/peditem`, {
          pedItemData: this.pedItemData
        }).then((res) => {

          console.log('then axios add new item:')
          console.log(res)

          this.produtoData = res.data[0]
          this.updating = false

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 2000
          })
          this.loadingPedItem = false
          this.showModalPedItem = false
          this.atualizaPagina()
        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          console.log(err.response)
          console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
          this.activeTab = 0
        })
      }
    },

    desassociarFrete() {
      console.log('desassociarFrete...')

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Desassociar frete do pedido?",
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "Desassociar",
        cancelButtonText: "Cancelar"
      }).then(check => {
        if (check.isConfirmed) {
          api.post(`${getBaseUrl()}api/destranspcota`, {
            iddata: this.pedidoData.id,
          }).then((res) => {
            console.log('then axios desassociarFrete')
            console.log(res.data)

            if(res.data.success){
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: res.data.message,
                showConfirmButton: false,
                timer: 1500
              }).then(() => {
                this.atualizaPagina()
              })
            } else {
              Swal.fire({
                position: "top-end",
                icon: "error",
                title: res.data.message,
                showConfirmButton: false,
                timer: 1500
              })
            }
          })
        }
      })
    },

    contratarFrete(){
      console.log('contratarFrete...')
      this.showModalCotarFrete = true
      if (this.cotaFreteListData.length === 0) {
        this.loadingCotarFrete = true

        api.get(`${getBaseUrl()}api/cotarfretepedido`, {
          params: {
            iddata: this.pedidoData.id,
          }
        }).then((res) => {
          console.log('res contratarFrete')
          console.log(res.data)

          if (!res.data['SDT_WSRetorno']) {
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: 'Cotação mal sucedida!',
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              Swal.fire({
                position: "center",
                icon: "error",
                title: res.data,
                showConfirmButton: true,
              }).then(() => {
                this.atualizaPagina()
              })
            })
          } else {
            console.log(res.data['SDT_WSRetorno']['Resultados'])
            // console.log(res.data[0]['SDT_WSRetorno'])
            this.cotaFreteListData = res.data['SDT_WSRetorno']['Resultados']

            // ordenar array pela WSOut_Frete_Val
            this.cotaFreteListData = this.cotaFreteListData.slice().sort(function (a, b) {
              return a.WSOut_Frete_Val - b.WSOut_Frete_Val;
            })

            let menorValor = 999999
            let menorPrazo = 999999
            this.cotaFreteListData.forEach((value) => {
              if (value.WSOut_Frete_Val < menorValor) {
                menorValor = value.WSOut_Frete_Val
              }
              if (value.WSOut_Prazo_Dias < menorPrazo) {
                menorPrazo = value.WSOut_Prazo_Dias
              }

              value.WSOut_Frete_Val = parseFloat(value.WSOut_Frete_Val)

            })

            this.cotaFreteListData.forEach((value) => {
              if (value.WSOut_Frete_Val === menorValor) {
                value['menorvalor'] = true
              }
              if (value.WSOut_Prazo_Dias === menorPrazo) {
                value['menorprazo'] = true
              }
            })

            this.loadingCotarFrete = false
          }
        })
      }
    },

    carregaVolumes(){
      console.log('carregaVolumes...')

      if(this.pedidoData.cotafrt_id){
        api.get(`${getBaseUrl()}api/cotavols`, {
        params: {cotafrt_id: this.pedidoData.cotafrt_id}
        }).then((res) => {
          console.log('res carregaVolumes')
          console.log(res.data)

          this.cotaFrtVolumes = res.data[0]
          this.showModalVolume = true
        })
      }
    },

    confVolume(){
      console.log('confVolume')
      console.log(this.cotaFrtVolumes)
      this.submittedVolume = true
      let todosVolValids = true

      this.cotaFrtVolumes.forEach((value) => {
        if (!value.largura > 0 || !value.altura > 0 || !value.comprim > 0 || !value.quant > 0) {
          todosVolValids = false
        }
      })

      if (todosVolValids) {
        console.log('formSubmit_volume_validado')
        this.showModalVolume = false
        this.cotaFrtVolume.cotafrt_id = this.pedidoData.cotafrt_id

        this.updating = true
        this.errosValid = []
        api.post(`${getBaseUrl()}api/cotafrtvols`, {
          cotafrtvolsData: this.cotaFrtVolumes,
          idcotafrt: this.pedidoData.cotafrt_id,
          origem: 'pedido'
        }).then((res) => {
          console.log('then axios')
          console.log(res)

          this.updating = false

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            this.atualizaPagina()
          })

        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
        })
      }
    },

    deletarVol(indexVol){
      console.log('deletarVol')
      console.log(indexVol)
      this.cotaFrtVolumes.splice(indexVol, 1)
    },

    addVolume(){
      console.log('addVolume')
      this.cotaFrtVolumes.push({
        'cotafrt_id': this.pedidoData.cotafrt_id,
        'altura': this.pedidoData.altura,
        'largura': this.pedidoData.largura,
        'comprim': this.pedidoData.comprimento,
        'quant': this.pedidoData.qtdvol
      });
    },

    escolherFrete(valorFrete, transp_cnpj, idCotacao, prazo, nomeTransp, email){
      console.log('escolherFrete')
      api.post(`${getBaseUrl()}api/contratafreteped`, {
        iddata: this.idData,
        valorFrete: valorFrete,
        transpCnpj: transp_cnpj,
        idCotacao: idCotacao,
        nomeTransp: nomeTransp,
        prazo: prazo,
        email: email
      }).then((res) => {
        console.log('then axios escolherFrete')
        console.log(res.data)

        if(res.data[0]){
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: res.data[0],
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            this.showModalCotarFrete = false
            this.atualizaPagina()
          })
        }else{
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: 'Contratação de frete falhou!',
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            this.showModalCotarFrete = false
            this.atualizaPagina()
          })
        }
      })
    },

    cotarFrete(){
      console.log('cotarfretepedido')
      api.post(`${getBaseUrl()}api/cotarfretepedido`, {
        iddata: this.idData
      }).then((res) => {
        console.log('res cotarFrete')
        console.log(res.data)
        //console.log(JSON.stringify(res.data))

        if(res.data.success){
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: res.data.mensagem,
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            this.pedidoData = res.data.pedido

            console.log('carregando volumes')
            this.carregaVolumes()
            //this.showModalVolume = true
          })
        }else{
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: res.data.mensagem,
            showConfirmButton: false,
            timer: 1500
          })
        }
      })
    },

    alteraObs() {
      console.log("alteraObs");
      if (this.pedidoData.status !== "FA" || this.pedidoData.status !== "CA" ) {
        this.showModalObs = true;
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status do pedido não permite alteração",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },

    pesqMovCompra() {
      console.log('pesqMovCompra')

      api.get(`${getBaseUrl()}api/pesqmovcompra`)
          .then((res) => {
            console.log('then axios');
            console.log(res);
            this.dtListPesqCompra = res.data
          })
    },

    escolheuMovCompra(idcompra) {
      console.log('escolheuMovCompra');

      api.post(`${getBaseUrl()}api/calcredicms`, {
        'iddata': this.idData,
        'idmovcompra': idcompra,
      }).then((res) => {
        console.log('then axios');
        console.log(res.data);

        const swalConfig = {
          icon: res.data.success ? "success" : "error",
          title: res.data.mensagem,
          text: res.data.detalhes,
        };

        Swal.fire(swalConfig).then(() => {
          this.showModalMovCompra = false;
          this.consultarEspelhoNFe();
        });
      });
    },

    downloadDanfeFocusnfe() {
      console.log('downloadPdfFocusnfe');

      api.get(`${getBaseUrl()}api/nota`, {
        params: {iddata: this.idData}
      }).then((res) => {
        this.nota_ide = res.data[0]
      })

      api.post(`${getBaseUrl()}api/dactefocusnfe`, {
        iddata: this.idData,
        tabela: 'pedido'
      }).then((res) => {
        console.log('then axios');
        console.log(res);

        if (res.data.success === false) {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: res.data.mensagem,
            showConfirmButton: false,
            timer: 3000
          })
        } else {
          console.log(this.pedidoData)
          const pdfData = res.data;

          const url = window.URL.createObjectURL(new Blob([pdfData]));

          const a = document.createElement('a');
          a.href = url;
          a.download = `${this.nota_ide['chave']}.pdf`;
          document.body.appendChild(a);
          a.click();

          window.URL.revokeObjectURL(url);
        }
      })
    },

    downloadXmlFocusnfe() {
      console.log('downloadXmlFocusnfe')

      console.log('requesting /nota...')
      api.get(`${getBaseUrl()}api/nota`, {
        params: {iddata: this.idData}
      }).then((res) => {
        console.log('response /nota:')
        console.log(res.data[0])
        this.nota_ide = res.data[0]
      })

      console.log('requesting /baixarxml...')
      api.post(`${getBaseUrl()}api/xmlfocusnfe`, {
        iddata: this.idData,
        tabela: 'pedido'
      }).then((res) => {
        console.log('response /baixarxml:')
        console.log(res);

        if (res.data.success === false) {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: res.data.mensagem,
            showConfirmButton: false,
            timer: 3000
          })
        } else {
          const xmlData = res.data;

          const url = window.URL.createObjectURL(new Blob([xmlData]));

          const a = document.createElement('a');
          a.href = url;
          a.download = `${this.nota_ide['chave']}.xml`;
          document.body.appendChild(a);
          a.click();

          window.URL.revokeObjectURL(url);
        }
      })
    },

    updateNfe() {
      console.log('updateNfe')
      api.post(`${getBaseUrl()}api/updfiscal`, {
        iddata: this.idData,
        'nota_ide': this.nota_ide,
        'nota_item': this.nota_item,
        'nota_infadic': this.nota_infadic
      }).then((res) => {
        console.log('then axios')
        console.log(res)

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: res.data.mensagem,
          showConfirmButton: false,
          timer: 1500
        }).then(() => {
          this.atualizaPagina()
        })
      })
    },

    consultarEspelhoNFe() {
      console.log('consultarEspelhoNFe')
      console.log('idData => ' + this.idData)

      api.get(`${getBaseUrl()}api/nota`, {
        params: {iddata: this.idData}
      }).then((res) => {
        console.log('then axios')
        console.log(res)

        this.nota_ide = res.data[0]
        this.nota_emit = res.data[1]
        this.nota_dest = res.data[2]
        this.nota_item = res.data[3]
        this.nota_total = res.data[4]
        this.nota_pag = res.data[5]
        this.nota_infadic = res.data[6]

      })

      this.showEspelhoNota = true
    },

    atualizaPagina() {
      window.location.reload();
    },

    gerarNotaFiscal() {
      console.log('gerarNotaFiscal')
      //Rota para gerar faturamento da nota fiscal
      api.post(`${getBaseUrl()}api/pedfocusnfe`, {idData: this.pedidoData.id})
          .then((res) => {
            console.log('then axios');
            console.log(res);

            let status = res.data.success ?? null
            let codigo = res.data.codigo ?? null
            let mensagem = res.data.mensagem ?? res.data.error ?? "Erro ao gerar nota fiscal"
            let detalhes = res.data.detalhes ?? null

            if (status === false) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: mensagem ?? detalhes,
                showConfirmButton: true,
                showCancelButton: true
              }).then((confirmed) => {
                if (confirmed.isConfirmed) {
                  if (res.data.natureza_id && res.data.natureza_id > 0) {
                    console.log('redirect to natureza')

                    let route = this.$router.resolve(`/natureza/editar/${res.data.natureza_id}`)
                    window.open(route.href, '_blank')
                  }
                }

                switch (codigo) {
                  case 1:
                    this.atualizaPagina();
                    break;
                }
              })
            } else {
              Swal.fire({
                position: "center",
                icon: "success",
                title: mensagem,
                timer: 2000,
                showConfirmButton: false
              }).then(() => {
                this.carregarDados()

                Swal.fire({
                    position: "center",
                    icon: "info",
                    title: "Geramos a sua nota!",
                    text: "Agora só falta a autorização 🙂",
                    showConfirmButton: false,
                    timer: 3000,
                  })
                  
                  setTimeout(()=> {
                    this.enviarFocusNFe()
                  }, 2000)
              })
            }
          })
    },

    enviarFocusNFe() {
      console.log('enviarFocusNFe')
      //Rota para gerar faturamento da nota fiscal
      this.loadingPedido = true
      api.post(`${getBaseUrl()}api/envfocusnfe`, {
        idData: this.pedidoData.id
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.loadingPedido = false

        if (res.data.codigo != null) {
          console.log('erro de informações da nota fiscal')
          switch (res.data.codigo) {

              //Erro de cadastro dos dados fiscais obrigatórios da nota
            case 1:
            case 2:
              this.popupEnvioFocusNFe(res)
              break;
            case 3: //Erro de cadastro da empresa => regime tributário
              Swal.fire({
                title: res.data.mensagem,
                text: `${res.data.detalhes} Deseja redirecionar para tela de cadastro?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Sim",
                cancelButtonText: "Não"
              }).then((result) => {
                if (result.isConfirmed) {
                  this.router.push('/clientes/list')
                }
              });
              break;
          }
        } else {
          this.retornoConsultaFocusNFe = res.data
          this.popupEnvioFocusNFe(this.retornoConsultaFocusNFe)
        }
      })
    },

    popupEnvioFocusNFe(retornoConsultaFocusNFe) {
      console.log('popupEnvioFocusNFe')
      console.log(retornoConsultaFocusNFe)

      if (retornoConsultaFocusNFe.success == true) {
        Swal.fire({
          position: "center",
          icon: "info",
          title: "Envio de NF-e sucedido 👍",
          showConfirmButton: false,
          timer: 3000
        }).then(() => {
          console.log(`status atual do pedido: ${this.pedidoData.stsefaz}`)

          if(this.pedidoData.stsefaz === "EV" || this.pedidoData.stsefaz === "AG"){
            setTimeout(() => {
              this.consultarFocusNFe();
            }, 10000);

            const TEMPO_FIXO = 10000; // 60 segundos
            let timerInterval;

            Swal.fire({
              position: "center",
              icon: "info",
              title: "Só mais um pouquinho",
              html: "Estamos aguardando autorização da sua NF-e!<br><br>⏳ <b></b> segundos",
              showConfirmButton: false,
              timer: TEMPO_FIXO,
              timerProgressBar: true,
              didOpen: () => {
                Swal.showLoading();

                const b = Swal.getPopup().querySelector("b");

                timerInterval = setInterval(() => {
                  const timeLeft = Swal.getTimerLeft();
                  if (timeLeft && b) {
                    b.textContent = Math.ceil(timeLeft / 1000);
                  }
                }, 250);
              },
              willClose: () => {
                clearInterval(timerInterval);
              }
            });

            this.modalRetornoEnvioFocusnfe = true
          } else {
            this.modalRetornoEnvioFocusnfe = true
          }
        })
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Envio de NF-e mal sucedido!",
          showConfirmButton: false,
          timer: 3000
        }).then(() => {
          this.modalErros = true
        })
      }
    },

    confirmarCancFocusNfe(justificativaCanc) {
      console.log('cancelarFocusNFe');
      console.log(justificativaCanc);

      api.post(`${getBaseUrl()}api/cancfocusnfe`, {
        iddata: this.idData,
        justificativa: this.justificativaCanc,
        tabela: 'pedido'
      }).then((res) => {
        console.log('then axios');
        console.log(res);

        if (res.data.success === true) {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: res.data.detalhes,
            showConfirmButton: false,
            timer: 3000
          }).then(
              /*this.atualizaPagina()*/
          )

        } else {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: res.data.detalhes,
            showConfirmButton: false,
            timer: 3000
          })
        }


        this.showModalCancFocusNfe = false;
      })
    },

    confirmarPedido(){
      console.log('confirmarPedido')

      Swal.fire({
        position: "center",
        icon: "warning",
        title: 'Deseja confirmar o pedido?',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        timer: 3000
      }).then((confirm) => {
        if(confirm.isConfirmed){
          console.log('confirmed')

          api.post(`${getBaseUrl()}api/confirmPedido`, {
            iddata: this.idData,
          }).then((res) => {
            console.log('then axios');
            console.log(res);

            if (res.data.success === true) {
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: 'Confirmação realizada com sucesso!',
                showConfirmButton: false,
                timer: 3000
              }).then(
                  this.atualizaPagina()
              )

            } else {
              Swal.fire({
                position: "top-end",
                icon: "error",
                title: 'Erro na confirmação do pedido!',
                showConfirmButton: false,
                timer: 3000
              })
            }
          })
        }
      })
    },

    confirmarCorrFocusNfe() {
      console.log('confirmarCorrFocusNfe')

      api.post(`${getBaseUrl()}api/corrfocusnfe`, {
        iddata: this.idData,
        justificativa: this.justificativaCorr,
        tabela: 'pedido'
      }).then((res) => {
        console.log('then axios');
        console.log(res);

        if (res.data.success === true) {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: 'Envio da carta de correção realizado!',
            showConfirmButton: false,
            timer: 3000
          }).then(
              this.atualizaPagina()
          )

        } else {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: 'Erro envio da carta de correção!',
            showConfirmButton: false,
            timer: 3000
          })
        }

        this.showModalCorrFocusNfe = false
      })
    },

    consultarFocusNFe(tipo, origem) {
      console.log('Consultar FocusNFe')

      this.loadingPedido = true
      api.post(`${getBaseUrl()}api/consfocusnfe`, {
        iddata: this.idData,
        tipoConsulta: tipo,
        tabela: 'pedido'
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.loadingPedido = false
        this.statusFocusnfe = res.data

        Swal.fire({
          position: "center",
          icon: "info",
          title: "Processo finalizado ✅",
          text: "Verifique os detalhes no status da autorização",
          showConfirmButton: false,
          timer: 3000
        })

        this.retornoConsultaFocusNFe = res.data
        this.tipoConsultaFocusNFe = false
        if (origem === 1) {
          this.modalConsultaSimplificada = true
        } else {
          this.carregarDados()
        }
      })
    },

    gerarWmsOs() {
      console.log('gerarWmsOs')

      api.get(`${getBaseUrl()}api/pedwmsos`, {
        params: {idData: this.pedidoData.id}
      }).then((res) => {
        console.log('then axios gerar_wms_os')
        console.log(res.data)


        // this.condPgtoData = res.data[0]
        // this.ultPedsData = res.data[1]
        //
        // let totalPed = 0
        // this.ultPedsData.forEach((value) => {
        //   totalPed += value.valorliq
        // });
        //
        // this.somaPedidosCli = totalPed
        // this.loadingCondPgto = false
      })

    },

    gerarSaldo() {
      console.log('gerarSaldo')

      api.get(`${getBaseUrl()}api/prgerasld`, {
        params: {iddata: this.pedidoData.id}
      }).then((res) => {
        console.log('then axios gerar_saldo')
        console.log(res.data)


        // this.condPgtoData = res.data[0]
        // this.ultPedsData = res.data[1]
        //
        // let totalPed = 0
        // this.ultPedsData.forEach((value) => {
        //   totalPed += value.valorliq
        // });
        //
        // this.somaPedidosCli = totalPed
        // this.loadingCondPgto = false
      })


    },

    cancelarSaldo() {
      console.log('cancelarSaldo')

      api.get(`${getBaseUrl()}api/prcancgerasld`, {
        params: {iddata: this.pedidoData.id}
      }).then((res) => {
        console.log('then axios prcancgerasld')
        console.log(res.data)


        // this.condPgtoData = res.data[0]
        // this.ultPedsData = res.data[1]
        //
        // let totalPed = 0
        // this.ultPedsData.forEach((value) => {
        //   totalPed += value.valorliq
        // });
        //
        // this.somaPedidosCli = totalPed
        // this.loadingCondPgto = false
      })


    },

    confirmarFormaPgto() {
      console.log('confirmarFormaPgto')
      this.showModalFormaPgto = false

      api.post(`${getBaseUrl()}api/pedido`, {
        pedidoData: this.pedidoData
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        // this.produtoData = res.data[0]
        this.loadingList = false

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })

      }).catch((err) => {
        console.log('erro axios')
        // console.log(err)
        // console.log(err.response)
        // console.log(err.response.data.errors)
        let erros = err.response.data.errors
        console.log(erros)
        console.log(typeof erros)
        let listaErros = []
        Object.keys(erros).forEach(key => {
          console.log(key, erros[key]);
          listaErros.push({
            'titulo': key,
            'mensagem': erros[key]
          })
        });
        this.errosValid = listaErros

      })


    },

    confirmarObs() {
      console.log('confrmarAlterObs')
      this.showModalObs = false
      this.loadingList = true

      console.log(`${this.pedidoData.obs} \n ${this.empresaData.obsadicionais}`)
      this.pedidoData.obsnf = `${this.pedidoData.obs} \n ${this.empresaData.obsadicionais}`

      this.salvarPedido()
    },

    confirmarCondPgto() {
      console.log('confirmarCondPgto')
      this.showModalCondPgto = false
      this.loadingPedido = true

      api.post(`${getBaseUrl()}api/pedido`, {
        pedidoData: this.pedidoData
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        // this.produtoData = res.data[0]

        if (res.data[1]) {
          this.financeirosData = res.data[1]
          if(this.financeirosData && this.financeirosData.emissao) {
            this.financeirosData.emissao_fmt = moment(this.financeirosData.emissao).format('DD/MM/YYYY')
          }
        }
        this.loadingPedido = false

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })

      }).catch((err) => {
        console.log('erro axios')
        // console.log(err)
        // console.log(err.response)
        // console.log(err.response.data.errors)
        let erros = err.response.data.errors
        console.log(erros)
        console.log(typeof erros)
        let listaErros = []
        Object.keys(erros).forEach(key => {
          console.log(key, erros[key]);
          listaErros.push({
            'titulo': key,
            'mensagem': erros[key]
          })
        });
        this.errosValid = listaErros

      })


    },

    escolheuConta() {
      console.log('selected contaData')
      this.loadingConta = true;
      this.loadingFinanc = true;
      console.log(this.pedidoData.banco_id);
      api.get(`${getBaseUrl()}api/cconta`, {
        params: { iddata: this.pedidoData.banco_id },
      }).then((res) => {
        console.log("then axios");
        // console.log(res.data);
        this.contaData = res.data[0];

        this.loadingConta = false;
        this.loadingFinanc = false;
        this.pedidoData.banco_id = this.contaData.id;
        this.pedidoData.banco = this.contaData.banco;
      });
    },

    escolheuCondPgto() {
      console.log('escolheuCondPgto')
      this.loadingCondPgto = true
      this.loadingFinanc = true;
      console.log(this.pedidoData.condpgto)
      api.get(`${getBaseUrl()}api/cpgtocod`, {
        params: {coddata: this.pedidoData.condpgto}
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.condPgtoData = res.data[0]
        this.ultPedsData = res.data[1]

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.pedidoData.condpgto = this.condPgtoData.codigo

        this.somaPedidosCli = totalPed
        this.loadingCondPgto = false
        this.loadingFinanc = false;
      })
    },

    escolheuFormaPgto() {
      console.log('escolheuFormaPgto')
      this.loadingFormaPgto = true
      this.loadingFinanc = true;
      console.log(this.pedidoData.formapgto)
      api.get(`${getBaseUrl()}api/fpgtocod`, {
        params: {coddata: this.pedidoData.formapgto}
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.formaPgtoData = res.data[0]
        this.ultPedsData = res.data[1]

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.pedidoData.formapgto = this.formaPgtoData.codigo

        this.somaPedidosCli = totalPed
        this.loadingFormaPgto = false
        this.loadingFinanc = false;
      })
    },

    pesqConta(evt){
      console.log('pesqFinConta')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/ccontapesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqConta = res.data
          this.dtListPesqConta.sort((a,b) => a.codigo - b.codigo);
        });
      }
    },

    pesqCondPgto(evt) {
      console.log('pesqCondPgto')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1) {
        this.loadingCondPgto = true
        this.loadingFinanc = true;
        this.pedidoData.condpgto = ''
        api.get(`${getBaseUrl()}api/cpgtopesq`, {
          params: {q: query}
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqCondPgto = res.data
        })
      }
    },

    pesqFormaPgto(evt) {
      console.log('pesqFormaPgto')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1) {
        this.loadingFormaPgto = true
        this.loadingFinanc = true;
        this.pedidoData.formapgto = ''
        api.get(`${getBaseUrl()}api/fpgtopesq`, {
          params: {q: query}
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqFormaPgto = res.data
        })
      }
    },


    selecionaCondPgto() {
      this.showModalCondPgto = true
      // console.log('selecionaCondPgto')
      // if (this.pedidoData.status === 'EL') {
      //   this.showModalCondPgto = true
      // }else{
      //   Swal.fire({
      //     position: "top-end",
      //     icon: "warning",
      //     title: "Status de pedido não permite alteração",
      //     showConfirmButton: false,
      //     timer: 1500
      //   })
      // }
    },

    selecionaFormaPgto() {
      console.log('selecionaFormaPgto')
      this.showModalFormaPgto = true
      // if (this.pedidoData.status === 'EL') {
      //   this.showModalFormaPgto = true
      // }else{
      //   Swal.fire({
      //     position: "top-end",
      //     icon: "warning",
      //     title: "Status de pedido não permite alteração",
      //     showConfirmButton: false,
      //     timer: 1500
      //   })
      // }
    },


    consultaImposto() {
      console.log('consultaImposto')

      api.get(`${getBaseUrl()}api/consimp`, {
        params: {idData: this.pedidoData.id}
      }).then((res) => {
        console.log('res consultar Imposto')
        console.log(res.data)


        // this.pedidoData = res.data[0]
        // this.loadingPedido = false
        //
        // Swal.fire({
        //   position: "top-end",
        //   icon: "success",
        //   title: "Nota Fiscal cancelada com sucesso!",
        //   showConfirmButton: false,
        //   timer: 1500
        // })


      })


    },

    cancelarPedido() {
      if (this.pedidoData.status === 'CO') {
        Swal.fire({
          position: "center",
          icon: "question",
          title: "Cancelar Pedido",
          text: "Esta operação é irreversível, tem certeza que deseja continuar?",
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          showConfirmButton: true,
        }).then(result => {
          if (result.value) {
            this.loadingPedido = true;

            api.get(`${getBaseUrl()}api/cancped`, {
              responseType: 'blob',
              params: {idData: this.pedidoData.id}
            }).then((res) => {
              console.log(res)
              this.pedidoData = res.data[0]
              this.loadingPedido = false
              window.location.reload();
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Pedido cancelada com sucesso!",
                showConfirmButton: false,
                timer: 1500
              })


            })
          }
        })
      } else {
        Swal.fire({
          position: "top-end",
          icon: "info",
          title: "Apenas Nota Fiscal com status Autorizada pode ser cancelada",
          showConfirmButton: false,
          timer: 1500
        })
      }


    },


    cancelarNFE() {

      if (this.pedidoData.stsefaz === 'AT') {
        Swal.fire({
          position: "center",
          icon: "question",
          title: "Cancelar Nota Fiscal",
          text: "Esta operação é irreversível, tem certeza que deseja continuar?",
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          showConfirmButton: true,
        }).then(result => {
          if (result.value) {
            this.loadingPedido = true;

            api.get(`${getBaseUrl()}api/cancnfe`, {
              responseType: 'blob',
              params: {idData: this.pedidoData.id}
            }).then((res) => {
              console.log('res cancelar NFe')
              console.log(res)
              this.pedidoData = res.data[0]
              this.loadingPedido = false

              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Nota Fiscal cancelada com sucesso!",
                showConfirmButton: false,
                timer: 1500
              })


            })
          }
        })
      } else {
        Swal.fire({
          position: "top-end",
          icon: "info",
          title: "Apenas Nota Fiscal com status Autorizada pode ser cancelada",
          showConfirmButton: false,
          timer: 1500
        })
      }


    },

    integrSeparaCorpem() {
      console.log('integrSeparaCorpem')
      if (this.mediaJsonSep && this.mediaJsonSep.id) {
        this.mediaJsonPedEnvio = this.mediaJsonSep.objenvio
        this.mediaJsonPedRet = this.mediaJsonSep.objretorno
        this.showModalMediaJson = true
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Separação de pedido não recebida.",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },


    integrConfEmbCorpem() {
      console.log('integrConfEmbCorpem')
      if (this.mediaJsonConfEmb && this.mediaJsonConfEmb.id) {
        this.mediaJsonPedEnvio = this.mediaJsonConfEmb.objenvio
        this.mediaJsonPedRet = this.mediaJsonConfEmb.objretorno
        this.showModalMediaJson = true
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Confirmação de Embarque do pedido não recebida.",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },


    criarDevolucao() {
      console.log('criarDevolucao')
      this.loadingPedido = true
      api.post(`${getBaseUrl()}api/pedevol`, {
        'iddata': this.idData
      }).then((res) => {
        console.log('then axios devolucao')
        console.log(res.data)

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Movimento criado com sucesso!",
          showConfirmButton: false,
          timer: 1500
        }).then(() => {
          this.$router.push({path: `/movdevol/editar/${res.data.id}`})
          this.loadingPedido = false
        })
      })
    },


    altPriorPed() {
      if (this.mediaJsonConfEmb && this.mediaJsonConfEmb.id) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Pedido já teve embarque confirmado, não é possível alterar prioridade",
          showConfirmButton: false,
          timer: 1500
        })
      } else {
        this.loadingPedido = true
        console.log('altPriorPed')
        api.get(`${getBaseUrl()}api/spaltprior`, {
          params: {idData: this.idData}
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          const retCorpem = JSON.stringify(res.data);
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Alteração de prioridade com Sucesso",
            text: retCorpem,
            showConfirmButton: false,
            timer: 2500
          })
          this.loadingPedido = false
        })
      }
    },

    cancelarPed() {
      console.log('cancelarPed')
      if (this.mediaJsonCanc && this.mediaJsonCanc.id) {
        this.mediaJsonPedEnvio = this.mediaJsonCanc.objenvio
        this.mediaJsonPedRet = this.mediaJsonCanc.objretorno
        this.showModalMediaJson = true
      } else {
        api.get(`${getBaseUrl()}api/spcancped`, {
          params: {idData: this.idData}
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.mediaJsonCanc = res.data[0]

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Cancelamento com Sucesso",
            text: this.mediaJsonCanc.objretorno,
            showConfirmButton: false,
            timer: 2500
          })
        })
      }
    },

    integrPedidoCorpem() {
      console.log('integrPedidoCorpem')
      if (this.mediaJsonPed && this.mediaJsonPed.id) {
        this.mediaJsonPedEnvio = this.mediaJsonPed.objenvio
        this.mediaJsonPedRet = this.mediaJsonPed.objretorno
        this.showModalMediaJson = true
      } else {
        this.loadingPedido = true
        api.get(`${getBaseUrl()}api/sppedsaida`, {
          params: {idData: this.idData}
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.mediaJsonPed = res.data[0]
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Integração Realizada com Sucesso",
            text: this.mediaJsonPed.objretorno,
            showConfirmButton: false,
            timer: 2500
          })
          this.loadingPedido = false
        })
      }
    },


    integrNFCorpem() {
      console.log('integrNFCorpem')
      if (this.pedidoData.status === 'FA') {
        if (this.mediaJsonSep && this.mediaJsonSep.id) {
          if (this.mediaJsonNota && this.mediaJsonNota.id) {
            this.mediaJsonPedEnvio = this.mediaJsonNota.objenvio
            this.mediaJsonPedRet = this.mediaJsonNota.objretorno
            this.showModalMediaJson = true
          } else {
            this.loadingPedido = true
            api.get(`${getBaseUrl()}api/spnotafisc`, {
              params: {idData: this.idData}
            }).then((res) => {
              console.log('then axios')
              console.log(res.data)
              this.mediaJsonNota = res.data[0]
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Integração Realizada com Sucesso",
                text: this.mediaJsonNota.objretorno,
                showConfirmButton: false,
                timer: 2500
              })
              this.loadingPedido = false
            })
          }
        } else {
          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: "Separação de pedido pendente, não é possível integrar",
            showConfirmButton: false,
            timer: 1500
          })
        }
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Pedido deve possuir status faturado para integrar NF, não é possível integrar",
          showConfirmButton: false,
          timer: 2500
        })
      }
    },


    copiarXML() {
      console.log('copiarXML')

      try {
        navigator.clipboard.writeText(this.xmlContent);
        this.showModalXML = false

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Conteúdo do arquivo XML disponível na sua área de transferência.",
          showConfirmButton: false,
          timer: 1500
        })

      } catch ($e) {
        console.log('erro ao copiar objeto')
        console.log($e)
      }

    },

    visualizarXML() {
      console.log('downloadXML')
      this.loadingPedido = true
      api.get(`${getBaseUrl()}api/getfile`, {
        responseType: 'blob',
        params: {pathData: this.mediasData[0].path}
      }).then((res) => {

        const reader = new FileReader()
        reader.addEventListener('loadend', (e) => {
          const text = e.srcElement.result
          this.xmlContent = xmlFormat(text, {
            indentation: '  ',
            filter: (node) => node.type !== 'Comment',
            collapseContent: true,
            lineSeparator: '\n'
          })
          this.showModalXML = true
        })
        reader.readAsText(res.data)

        this.loadingPedido = false
      })
    },


    downloadDanfe() {
      console.log('downloadDanfe')
      this.loadingPedido = true

      api.get(`${getBaseUrl()}api/peddanfe`, {
        responseType: 'blob',
        params: {idData: this.pedidoData.id}
      }).then((res) => {
        console.log('res down')
        console.log(res)

        var fileURL = window.URL.createObjectURL(new Blob([res.data]))
        var fileLink = document.createElement('a')
        fileLink.href = fileURL
        fileLink.setAttribute('download', 'danfe_pedido_' + this.pedidoData.id + '.pdf')
        document.body.appendChild(fileLink);

        console.log('fileLink')
        console.log(fileURL)

        fileLink.click();
        this.loadingPedido = false
      })

    },

    // downloadMiniDanfe(){
    //   console.log('downloadDanfe')
    //   this.loadingPedido = true
    //
    //   api.get(`${getBaseUrl()}api/peddanfeet`, {
    //     responseType: 'blob',
    //     params: { idData: this.pedidoData.id }
    //   }).then((res) => {
    //     console.log('res down')
    //     console.log(res)
    //
    //     var fileURL = window.URL.createObjectURL(new Blob([res.data]))
    //     var fileLink = document.createElement('a')
    //     fileLink.href = fileURL
    //     fileLink.setAttribute('download', 'etiqueta_pedido_' + this.pedidoData.id +'.pdf')
    //     document.body.appendChild(fileLink);
    //
    //     console.log('fileLink')
    //     console.log(fileURL)
    //
    //     fileLink.click();
    //     this.loadingPedido = false
    //   })
    //
    // },

    downloadMiniDanfe() {
      console.log('downloadMiniDanfe')
      this.loadingList = true
      api.get(`${getBaseUrl()}api/peddanfecu`, {
        responseType: 'blob',
        params: {
          iddata: this.pedidoData.id
        }
      }).then((res) => {
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'mini_danfe.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
        this.loadingList = false
      })
    },

    downloadXML() {
      console.log('downloadXML')
      this.loadingPedido = true
      api.get(`${getBaseUrl()}api/getfile`, {
        responseType: 'blob',
        params: {pathData: this.mediasData[0].path}
      }).then((res) => {
        var fileURL = window.URL.createObjectURL(new Blob([res.data]))
        var fileLink = document.createElement('a')
        fileLink.href = fileURL
        fileLink.setAttribute('download', 'xml_nota_' + this.pedidoData.codigo + '.xml')
        document.body.appendChild(fileLink)
        const reader = new FileReader()
        reader.addEventListener('loadend', (e) => {
          const text = e.srcElement.result
          this.xmlContent = xmlFormat(text, {
            indentation: '  ',
            filter: (node) => node.type !== 'Comment',
            collapseContent: true,
            lineSeparator: '\n'
          })
        })
        reader.readAsText(res.data)
        fileLink.click();
        this.loadingPedido = false
      })
    },

    emailXML() {
      console.log('emailXML')
      this.showModalEnviarXML = false
      this.loadingPedido = true
      api.get(`${getBaseUrl()}api/emailxml`, {
        params: {
          pathData: this.mediasData[0].path,
          idData: this.pedidoData.id,
          mailCli: this.clienteData.email,
          envCli: this.envCliEnviarXml,
          envDanfe: this.envDanfeEnviarXml,
          mailAdic: this.emailAdicEnviarXml
        }
      }).then((res) => {
        console.log(res.data)
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "E-mail enviado com sucesso",
          showConfirmButton: false,
          timer: 1500
        })
        this.loadingPedido = false
      })
    },

    nomeStatusLog(sigla) {
      console.log(sigla)
      let result = ''
      switch (sigla) {
        case 'CR':
          result = 'Orçamento Criado'
          break
        case 'CO':
          result = 'Confirmado'
          break
        case 'FA':
          result = 'Faturado'
          break
        case 'CX':
          result = 'Cancelado'
          break
        case 'SP':
          result = 'Confirmação Separação'
          break
        case 'EB':
          result = 'Confirmação Embarque'
          break
      }
      return result
    },

    nomeStatusSefaz(sigla) {
      console.log(sigla)
      let result = 'Não Enviado'
      switch (sigla) {
        case 'XM':
          result = 'XML Disponível'
          break
        case 'EN':
          result = 'Lote Enviado'
          break
        case 'RJ':
          result = 'Rejeição'
          break
        case 'AT':
          result = 'Autorizado'
          break
        case 'CA':
          result = 'Cancelado'
          break
        case 'NG':
          result = 'Nota fiscal negada'
          break
        case 'EV':
          result = 'Envio para Sefaz pendente'
          break
        case 'AG':
          result = 'Aguardando autorização'
          break
        case null:
        case '':
          result = 'Aguardando gerar nota fiscal'
      }
      return result
    },

    emitirNFe() {

      console.log(this.pedidoData.formapgto)
      console.log(this.pedidoData.condpgto)
      console.log('emitirNFe')

      if (!this.pedidoData.formapgto) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Favor selecionar forma de pagamento antes de faturar",
          showConfirmButton: false,
          timer: 2500
        })
      } else if (!this.pedidoData.condpgto) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Favor selecionar condição de pagamento antes de faturar",
          showConfirmButton: false,
          timer: 2500
        })
      } else {


        Swal.fire({
          position: "center",
          icon: "question",
          title: "Faturar Pedido",
          text: "Esta operação é irreversível, tem certeza que deseja continuar?",
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          showConfirmButton: true,
        }).then(result => {
          if (result.value) {
            this.loadingPedido = true

            api.post(`${getBaseUrl()}api/pednfe`, {
              idData: this.pedidoData.id
            }).then((res) => {
              console.log('then axios')
              console.log(res)


              // if (res.data.includes('Rejeicao')){
              //
              //   Swal.fire({
              //     position: "center",
              //     icon: "error",
              //     title: "Erro Procedimento",
              //     text: res.data,
              //     confirmButtonText: "Confirmar",
              //     showConfirmButton: true,
              //   })
              //
              //
              //
              // } else {
              this.pedidoData = res.data[0]
              this.pedLogsData = res.data[1]
              this.mediasData = res.data[2]


              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Pedido Faturado, arquivo xml disponível para envio",
                showConfirmButton: false,
                timer: 1500
              }).then((res) => {
                console.log(res)
                this.loadingPedido = false
              })
              // }

            }).catch((err) => {
              console.log('erro axios emitirNFe')
              console.log(err)

              this.loadingPedido = false

              // Swal.fire({
              //   position: "top-end",
              //   icon: "success",
              //   title: "Pedido Faturado, arquivo xml disponível para envio",
              //   showConfirmButton: false,
              //   timer: 1500
              // })

              // Swal.fire({
              //   position: "center",
              //   icon: "error",
              //   title: "Erro Procedimento",
              //   text: 'err',
              //   confirmButtonText: "Confirmar",
              //   showConfirmButton: true,
              // })


            })

          }
        })
      }

    },

    enviarNFe() {
      console.log('emitirNFe')
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Enviar Lote com Nota Eletrônica",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.loadingPedido = true


          api.post(`${getBaseUrl()}api/pednfeenv`, {
            idData: this.pedidoData.id
          }).then((res) => {
            console.log('then axios')
            console.log(res)
            if (res.data.includes('Rejeicao')) {
              Swal.fire({
                position: "center",
                icon: "error",
                title: "Erro Procedimento",
                text: res.data,
                confirmButtonText: "Fechar",
                showConfirmButton: true,
              })
            } else {
              this.pedidoData = res.data[0]
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Lote de Nota enviado com sucesso",
                showConfirmButton: false,
                timer: 1500
              })
            }
            this.loadingPedido = false

          }).catch((err) => {
            console.log('erro axios')
            console.log(err)

            this.loadingPedido = false

            Swal.fire({
              position: "center",
              icon: "error",
              title: "Erro Procedimento",
              text: err,
              confirmButtonText: "Fechar",
              showConfirmButton: true,
            })
          })

        }
      })

    },

    consultarNFe() {
      console.log('consultarNFe')
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Consultar Lote Nota Fiscal",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.loadingPedido = true

          api.post(`${getBaseUrl()}api/postnfeconschave`, {
            idData: this.pedidoData.id
          }).then((res) => {
            console.log('then axios')
            console.log(res)


            if (res.data[1].motivo.includes('Rejeicao')) {
              Swal.fire({
                position: "center",
                icon: "error",
                title: "Erro Procedimento",
                text: res.data[1].motivo,
                confirmButtonText: "Fechar",
                showConfirmButton: true,
              })
            } else {
              this.pedidoData = res.data[0]

              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Nota Fiscal Autorizada com sucesso",
                showConfirmButton: false,
                timer: 1500
              })
            }

            this.loadingPedido = false

          }).catch((err) => {
            console.log('erro axios')
            console.log(err)

            this.loadingPedido = false
          })

        }
      })

    },

    visualizarCotacaoFrete() {
      if (this.pedidoData.cotafrt_id > 0) {
        this.$router.push(`/cotafrt/editar/${this.pedidoData.cotafrt_id}`);
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Pedido não possui cotação de frete",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    abrirOrcamento() {
      if (this.pedidoData.orcamento_id > 0) {
        this.$router.push(`/orcamento/editar/${this.pedidoData.orcamento_id}`);
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Pedido não foi criado a partir de orçamento",
          showConfirmButton: false,
          timer: 1500
        })
      }

    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 4});
      }
      return 0.00;
    },

    formatBigDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 6 });
      }else{
        console.log('bigfloat convertion error')
        return "0,00";
      }
    },
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" :status="pedidoData.status"/>

    <Loader v-if="loadingPedido" style="min-height: 400px;">
    </Loader>

    <div class="row" v-if="!loadingPedido">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">

            <!--Cabeçalho butons-->
            <div class="d-flex align-items-start mb-5">

              <!--<b-button variant="outline-primary" class="mx-2" @click="emitirNFe" v-if="!pedidoData.stsefaz && pedidoData.status === 'CO'">
                <i class="bx bx-money font-size-16 align-middle me-2"></i>
                Faturar
              </b-button> -->

              <b-button
                  variant="outline-success"
                  class="mx-2"
                  :disabled="pedidoData.financ_id"
                  @click="gerarFinanceiro">
                <i class="bx bx-money font-size-16 align-middle me-2"></i>
                Gerar Financeiro
              </b-button>

              <b-button variant="outline-primary" class="mx-2" @click="consultarEspelhoNFe"
                        v-if="pedidoData.status === 'FA'">
                <i class="bx bx-search-alt font-size-16 align-middle me-2"></i>
                Espelho NF-e
              </b-button>

              <b-button
                  variant="outline-primary"
                  class="mx-2"
                  @click="downloadEspelhoPedido">
                <i class="bx bx-file font-size-16 align-middle me-2"></i>
                Espelho Pedido
              </b-button>

              <b-button variant="outline-warning" class="mx-2" @click="novoProduto"
                        v-if="opcaoadditem && (flagEmprParamItem && (pedidoData.stsefaz == '' || pedidoData.stsefaz == null && pedidoData.status === 'CO'))">
                <i class="bx bx-plus font-size-16 align-middle me-2"></i>
                Adicionar novo item
              </b-button>

              <b-button variant="outline-warning" class="mx-2" @click="gerarNotaFiscal"
                        v-if="pedidoData.stsefaz == '' || pedidoData.stsefaz == null && pedidoData.status === 'CO'">
                <i class="bx bx-money font-size-16 align-middle me-2"></i>
                Gerar NF-e
              </b-button>

              <b-button  title="Criar nova contratação de frete"
                variant="outline-info" class="mx-2" @click="cotarFrete" :disabled="pedidoData.id === 0" v-if="pedidoData.status === 'CO' && !pedidoData.cotafrt_id && !pedidoData.transp">
                <i class="bx bxs-truck font-size-16 align-middle me-2"></i>
                Registrar Frete
              </b-button>

              <b-button variant="success" class="mx-2" @click="contratarFrete" :disabled="pedidoData.id === 0" v-if="pedidoData.status === 'CO' && pedidoData.cotafrt_id && !pedidoData.transp">
                <i class="bx bxs-right-arrow-circle font-size-16 bx-fade-right"></i>
                <i class="bx bx-money font-size-16 align-middle me-2"></i>
                Contratar Frete
              </b-button>

              <b-button variant="outline-info" class="mx-2" v-if="pedidoData.status === 'CO' && pedidoData.cotafrt_id && pedidoData.transp" @click="desassociarFrete">
                  <i class="bx bxs-truck font-size-16 align-middle me-2"></i>
                  <i class="bx bx-unlink font-size-16 align-middle text-danger" title="Desassociar"></i>
                Desassociar Frete
              </b-button>

              <b-button variant="outline-info" class="mx-2" v-if="pedidoData.cotafrt_id && pedidoData.transp" @click="visualizarCotacaoFrete">
                <i class="bx bxs-truck font-size-16 align-middle me-2"></i>
                Visualizar cotação de frete
              </b-button>

              <b-button title="Cadastrar volumes para a contratação de frete"
                variant="warning" class="mx-2" @click="carregaVolumes" :disabled="pedidoData.id === 0" v-if="pedidoData.status === 'CO' && pedidoData.cotafrt_id && !pedidoData.transp">
                <i class="bx bx-box font-size-16 align-middle me-2"></i>
                Volumes da cotação
              </b-button>

              <b-button variant="outline-success" class="mx-2" @click="enviarFocusNFe"
                        v-if="pedidoData.stsefaz === 'EV' && pedidoData.status === 'FA'">
                <i class="bx bx-rocket font-size-16 align-middle me-2"></i>
                Enviar para autorização
              </b-button>

              <b-button variant="outline-primary" class="mx-2" @click="showModalMovCompra = true"
                        v-if="pedidoData.status === 'FA' && pedidoData.stsefaz === 'EV'">
                <i class="bx bx-receipt font-size-16 align-middle me-2"></i>
                Adicionar cálculo de redução de imposto
              </b-button>

              <b-button variant="outline-primary" class="mx-2" @click="tipoConsultaFocusNFe = true"
                        v-if="pedidoData.stsefaz === 'NG' || pedidoData.stsefaz === 'AT' || pedidoData.stsefaz === 'AG' && pedidoData.status === 'FA'">
                <i class="bx bx-file-find font-size-16 align-middle me-2"></i>
                Consultar status da NF-e
              </b-button>

              <b-button variant="outline-danger" class="mx-2" @click="showModalCancFocusNfe = true"
                        v-if="pedidoData.stsefaz === 'AT' && pedidoData.status === 'FA'">
                <i class="bx bx-x font-size-16 align-middle me-2"></i>
                Cancelar NFe
              </b-button>

              <b-button variant="outline-primary" class="mx-2" @click="showModalCorrFocusNfe = true"
                        v-if="pedidoData.stsefaz === 'AT' && pedidoData.status === 'FA'">
                <i class="bx bx-edit font-size-16 align-middle me-2"></i>
                Enviar carta de correção
              </b-button>

              <b-dropdown
                  ngbDropdown
                  menu-class="dropdown-menu-md dropdown-menu-end mx-2"
                  right
                  variant="light"
                  v-if="pedidoData.status === 'FA' && pedidoData.stsefaz === 'AT'"
              >
                <template v-slot:button-content>
                  <i class="bx bx-download me-1"></i>
                  <span class="d-none d-sm-inline-block" ngbDropdownToggle>
                      Baixar
                      <i class="mdi mdi-chevron-down"></i>
                    </span>
                </template>


                <div v-if="!loadingPedido">


                  <a class="dropdown-item text-primary text-center"
                     @click="downloadXmlFocusnfe"
                     href="javascript: void(0);">
                    XML
                  </a>
                  <b-dropdown-divider></b-dropdown-divider>
                  <a class="dropdown-item text-primary text-center"
                     @click="downloadDanfeFocusnfe"
                     href="javascript: void(0);">
                    PDF Danfe
                  </a>

                </div>

              </b-dropdown>

              <!-- BOTÕES ANTERIORES (ROGÉRIO)
              <b-button variant="outline-primary" class="mx-2" @click="enviarNFe" v-if="pedidoData.stsefaz === 'XM'">
                <i class="bx bx-check font-size-16 align-middle me-2"></i>
                Enviar Nota Eletrônica
              </b-button>

              <b-button variant="outline-primary" class="mx-2" @click="consultarNFe" v-if="pedidoData.stsefaz === 'EN'">
                <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                Consultar Lote Sefaz
              </b-button>

              <b-button variant="outline-info" class="mx-2" @click="downloadXML" v-if="pedidoData.status === 'FA'">
                <i class="bx bx-download font-size-16 align-middle me-2"></i>
                Download XML
              </b-button>

              <b-button variant="outline-success" class="mx-2" @click="showModalEnviarXML = true" v-if="pedidoData.status === 'FA'">
                <i class="bx bx-send font-size-16 align-middle me-2"></i>
                Enviar E-mail XML
              </b-button>

              <b-button variant="outline-warning" class="mx-2" @click="visualizarXML" v-if="pedidoData.status === 'FA'">
                <i class="bx bx-search-alt-2 font-size-16 align-middle me-2"></i>
                Visualizar XML
              </b-button>-->

              <!--                            <b-button variant="outline-success" class="mx-2" @click="downloadDanfe" v-if="pedidoData.status === 'FA'">
                              <i class="bx bx-printer font-size-16 align-middle me-2" ></i>
                              Imprimir
                            </b-button>-->

              <b-button variant="outline-warning" class="mx-2" @click="abrirOrcamento">
                <i class="bx bxs-rocket font-size-16 align-middle me-2"></i>
                Abrir Orçamento
              </b-button>

              <!--
              <b-button variant="outline-danger" class="mx-2" @click="criarDevolucao">
                <i class="bx bx-move-horizontal font-size-16 align-middle me-2"></i>
                Criar Devolução
              </b-button>-->

              <b-button variant="outline-info"
                        class="mx-2"
                        @click="gerarSaldo"
                        v-if="userLogged && userLogged.email === 'admin@admin.com.br'">
                <i class="bx bx-download font-size-16 align-middle me-2"></i>
                Gerar Saldo (APENAS ADMIN)
              </b-button>

              <b-button
                  variant="outline-info"
                  class="mx-2"
                  @click="cancelarSaldo"
                  v-if="userLogged && userLogged.email === 'admin@admin.com.br'">
                <i class="bx bx-download font-size-16 align-middle me-2"></i>
                Cancelar Saldo (APENAS ADMIN)
              </b-button>

              <b-button
                  variant="outline-info"
                  class="mx-2"
                  @click="gerarWmsOs"
                  v-if="userLogged && userLogged.email === 'admin@admin.com.br'">
                <i class="bx bx-download font-size-16 align-middle me-2"></i>
                Gerar OS (APENAS ADMIN)
              </b-button>

              <!-- <b-button variant="outline-primary" class="mx-2" @click="integrPedidoCorpem">
                              <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                              Integração Pedido Corpem
                            </b-button>-->

              <!--                            <b-button variant="outline-primary" class="mx-2" @click="integrNFCorpem" v-if="pedidoData.status === 'FA'">
                              <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                              Integrar Nota Fiscal Corpem
                            </b-button>-->

              <!--                            <b-button variant="outline-danger" class="mx-2" @click="cancelarPed">
                              <i class="bx bx-block font-size-16 align-middle me-2"></i>
                              Cancelar Corpem
                            </b-button>-->

              <!--                            <b-button variant="outline-danger" class="mx-2" @click="altPriorPed">
                              <i class="bx bx-block font-size-16 align-middle me-2"></i>
                              Alterar Prioridade Corpem
                            </b-button>-->

              <!--<b-dropdown
                  ngbDropdown
                  menu-class="dropdown-menu-md dropdown-menu-end mx-2"
                  right
                  variant="light">
                <template v-slot:button-content>
                  <i class="mdi mdi-printer me-1"></i>
                  <span class="d-none d-sm-inline-block" ngbDropdownToggle>
                      Imprimir
                      <i class="mdi mdi-chevron-down"></i>
                    </span>
                </template>


                <div v-if="!loadingPedido">


                  <a class="dropdown-item text-primary text-center"
                     @click="downloadDanfe"
                     href="javascript: void(0);">
                    Danfe
                  </a>
                  <b-dropdown-divider></b-dropdown-divider>
                  <a class="dropdown-item text-primary text-center"
                     @click="downloadMiniDanfe"
                     href="javascript: void(0);">
                    Danfe Etiqueta
                  </a>
                </div>
              </b-dropdown>-->

              <b-dropdown
                  ngbDropdown
                  class="mx-2"
                  menu-class="dropdown-menu-md dropdown-menu-end mx-2"
                  right
                  variant="light">
                <template v-slot:button-content>
                  <i class="mdi mdi-layers-outline me-1"></i>
                  <span class="d-none d-sm-inline-block" ngbDropdownToggle>
                      Funções WMS
                      <i class="mdi mdi-chevron-down"></i>
                    </span>
                </template>


                <div v-if="!loadingPedido">

                  <b-dropdown-divider></b-dropdown-divider>
                  <a class="dropdown-item text-primary text-center"
                     @click="integrPedidoCorpem"
                     href="javascript: void(0);">
                    Integração Pedido WMS
                  </a>
                  <b-dropdown-divider></b-dropdown-divider>
                  <a class="dropdown-item text-primary text-center"
                     @click="integrSeparaCorpem"
                     href="javascript: void(0);">
                    Integração Separação WMS
                  </a>
                  <b-dropdown-divider></b-dropdown-divider>
                  <a class="dropdown-item text-primary text-center"
                     @click="integrNFCorpem"
                     href="javascript: void(0);">
                    Integração NF WMS
                  </a>
                  <b-dropdown-divider></b-dropdown-divider>
                  <a class="dropdown-item text-primary text-center"
                     @click="cancelarPed" v-if="pedidoData.status === 'FA'"
                     href="javascript: void(0);">
                    Cancelar WMS
                  </a>
                  <b-dropdown-divider></b-dropdown-divider>
                  <a class="dropdown-item text-primary text-center"
                     @click="altPriorPed" v-if="pedidoData.status === 'FA'"
                     href="javascript: void(0);">
                    Alterar Prioridade WMS
                  </a>
                  <b-dropdown-divider></b-dropdown-divider>
                  <a class="dropdown-item text-primary text-center"
                     @click="integrConfEmbCorpem" v-if="pedidoData.status === 'FA'"
                     href="javascript: void(0);">
                    Confirmação de Embarque
                  </a>
                </div>

              </b-dropdown>

              <button class="btn btn-success"
                      @click="confirmarPedido"
                      v-if="pedidoData.status === 'EL' && pedItensData && pedItensData.length > 0"
              >
                <i class="mdi mdi-rocket-launch me-1 text-end"></i> SUCESSO!
              </button>
            </div>

            <!--Body Layout-->
            <div class="row">
              <div class="mb-3 col-12">
                <div class="row justify-content-between border p-3 rounded mt-1" style="min-height: 120px">
                  <div v-if="clienteData && clienteData.codigo" class="col-5">
                    <div class="d-flex align-items-baseline">
                      <h4 class="font-size-14 mb-1">
                        Informações do Cliente
                      </h4>
                      <div class="col-4 ms-auto me-1 text-end">
                        <router-link
                            :to="`/cliente/editar/${clienteData.id}`"
                            class="text-info"
                            v-if="clienteData"
                            target="_blank"
                        >
                          Detalhes Cliente
                          <i class="mdi mdi-arrow-right ms-1"></i>
                        </router-link>
                      </div>
                    </div>
                    <div class="d-flex align-items-center mb-2">
                      <div class="mb-1 me-3">
                        <i class="mdi mdi-account-circle text-primary h1"></i>
                      </div>

                      <div class="d-flex col-6">
                        <h5>{{ clienteData.nome }}</h5>
                        <h5 class="ms-2 ">
                          <span class="badge bg-success align-bottom" style="padding: 3px 15px"
                                :class="clienteData.status === 'A' ? 'badge-soft-success' : 'badge-soft-danger'">
                            {{ clienteData.status === 'A' ? 'Ativo' : 'Inativo' }}
                          </span>
                        </h5>
                      </div>
                    </div>
                    <div>
                      <p class="text-muted mb-1">CNPJ: {{ clienteData.cnpj }}</p>
                      <p class="text-muted mb-1">Código: {{ clienteData.codigo }}</p>
                      <p class="text-muted mb-1">
                        <i class="mdi mdi-map-marker-outline"></i>
                         {{ `${clienteData.cidade} - ${clienteData.estado} `}}
                      </p>
                    </div>
                  </div>

                  <div class="col-1 d-flex justify-content-center">
                    <hr style="width: 1px;height: 100px;background-color: #000;border: none;margin: 0 10px;">
                  </div>

                  <div class="col-5">
                    <div class="d-flex align-items-baseline" @click="showModalEditaTransp = true" style="cursor: pointer">
                      <h5 class="font-size-14 mb-1">
                        Informações do Transportador
                      </h5>
                      <span class="ms-3">
                        <i class="bx bx-pencil font-size-12 align-middle mx-1"/>
                        Editar
                      </span>

                      <div class="col-4 ms-auto me-1 text-end" v-if="transpData">
                        <router-link
                            :to="`/cliente/editar/${transpData.id}`"
                            class="text-info"
                            target="_blank"
                        >
                          Detalhes Transp.
                          <i class="mdi mdi-arrow-right ms-1"></i>
                        </router-link>
                      </div>
                    </div>

                    <div v-if="!transpData || !transpData.cnpj" class="mt-3">
                      <h5 class="text-danger">Transportadora não encontrada</h5>
                    </div>

                    <div v-else>
                      <div class="d-flex align-items-center mb-2 mt-2">
                        <div class="mb-1 me-3">
                          <i class="mdi mdi-truck-outline text-primary h1"></i>
                        </div>

                        <div class="d-flex col-6">
                          <h5>{{ transpData.fantasia ?? transpData.nome }}</h5>
                          <h5 class="ms-2">
                            <span class="badge bg-success align-bottom" style="padding: 3px 15px"
                                  :class="transpData.status === 'A' ? 'badge-soft-success' : 'badge-soft-danger'">
                              {{ transpData.status === 'A' ? 'Ativo' : 'Inativo' }}
                            </span>
                          </h5>
                        </div>
                      </div>

                      <div>
                        <p class="text-muted mb-1">CNPJ: {{ transpData.cnpj }}</p>
                        <p class="text-muted mb-1">Código: {{ transpData.codigo }}</p>
                        <p class="text-muted mb-1">
                          <i class="mdi mdi-map-marker-outline"></i>
                          {{ `${transpData.cidade} - ${transpData.estado}` }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="mb-3 col-12">
                <div class="border p-3 rounded mt-1" style="min-height: 120px">
                  <div class="d-flex align-items-baseline">
                        <span class="text-primary font-size-20 me-2">
                          <i class="mdi mdi-clipboard-list-outline"></i>
                        </span>
                    <h4 class="font-size-14 mb-0">
                      Informações do Pedido
                    </h4>

                    <h6 v-if="orcamentosAgregadosData && orcamentosAgregadosData.length > 0"
                        class="ms-auto me-2">
                      Orçamento(s)(origem):
                      <span class="text-muted ms-2">
                        <template v-for="(orcamento, index) in orcamentosAgregadosData"
                                  :key="orcamento.id">
                          <span v-if="index > 0"> | </span>
                          <span>ID: {{ orcamento.id }} - Cód.: {{ orcamento.numped ? orcamento.numped : orcamento.codigo }}</span>
                        </template>
                      </span>
                    </h6>
                  </div>

                  <div class="row justify-content-between text-muted mt-3">
                    <div class="col-1">
                      <h6><strong>Valor Bruto:</strong></h6>
                      <h6>R${{ formatDecimal(pedidoData.valorbrt) }}</h6>
                    </div>

                    <div class="col-1">
                      <h6><strong>Valor Líquido:</strong></h6>
                      <h6>R${{ formatDecimal(valorTotalCalculadoDosItens) }}</h6>
                    </div>

                    <div class="col-1">
                      <h6 class="me-4"><strong>Valor Frete:</strong></h6>
                      <div class="d-flex" style="cursor: pointer;" title="Editar valor de frete" @click="showModalEditaVlrf = true">
                        <h6>R${{ formatDecimal(pedidoData.valorfrete) }}</h6>
                        <i class="bx bx-pencil font-size-12 align-middle me-1"/>
                      </div>
                    </div>

                    <div class="col-1">
                      <h6><strong>Desconto:</strong></h6>
                      <h6>R${{ formatDecimal(pedidoData.desconto) }}</h6>
                    </div>

                    <div class="col-1">
                      <h6><strong>Peso Bruto:</strong></h6>
                      <h6>{{ formatDecimal(somaPesoBruto)}}Kg</h6>
                    </div>

                    <div class="col-1">
                      <h6><strong>Peso Líquido:</strong></h6>
                      <h6>{{ formatDecimal(pedidoData.pesoliq)}}Kg</h6>
                    </div>

                    <div class="col-1">
                      <h6><strong>Cubagem:</strong></h6>
                      <h6>{{ formatDecimal(cubagemTotal) }}m³</h6>
                    </div>

                    <div class="col-1" style="cursor: pointer" @click="buscaDadosVolumes" title="Verificar volumes">
                     <h6><strong>Quant. Vol.:</strong></h6>
                      <h6 class="text-center">{{ formatInteger(volumesquantidade)}}</h6>
                    </div>

                  </div>
                </div>
              </div>

              <div class="mb-3 col-12">
                <div class="border p-3 rounded mt-1" style="min-height: 120px">
                  <div class="d-flex justify-content-between">
                    <div class="col-4">
                      <div class="d-flex align-items-baseline mb-2">
                        <span class="text-info font-size-20 me-2">
                          <i class="mdi mdi-clipboard-file-outline"></i>
                        </span>
                        <h4 class="font-size-14 mb-0">
                          Informações de NF-e
                        </h4>
                        <h6 class="ms-auto">
                          {{`( Nro NF-e: ${this.nota_ide.nnf ?? ''} | Série: ${this.nota_ide.serie ?? ''} )`}}
                        </h6>
                      </div>

                      <div class="row">
                        <div class="row text-muted mt-1">
                          <div class="col-6">
                            <h6>Dt. de emissão:</h6>
                            <h5>{{ formatDateTime(this.nota_ide.dhemi) ?? '' }}</h5>
                          </div>
                          <div class="col-6">
                            <h6>Stts. Faturamento:
                              <b-button title="Consulta Focus NF-e"
                                        class="badge bg-primary font-size-11 align-bottom ms-3 "
                                        @click="consultarFocusNFe(1, 2)">
                                <i class="dx-icon-refresh mx-2"></i>
                              </b-button>
                            </h6>
                            <h5>
                                  <span class="badge bg-success align-bottom"
                                        :class="pedidoData.stsefaz === 'EN' ? 'badge-soft-warning' :
                                            pedidoData.stsefaz === 'AT' ? 'badge-soft-success' :
                                            pedidoData.stsefaz === 'XM' ? 'badge-soft-warning' :
                                            pedidoData.stsefaz === 'AG' ? 'badge-soft-warning' : 'badge-soft-danger'">

                                    {{ nomeStatusSefaz(pedidoData.stsefaz) }}
                                  </span>
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>

                    <hr class="mx-4" style="width: 1px;height: 50px;background-color: #000;border: none;margin: 0 10px;">

                    <div class="col-3">
                      <div class="d-flex align-items-center mb-2" v-if="pedidoData.tipo">
                          <span class="text-success font-size-20 me-2">
                            <i class="mdi mdi-account-cash"></i>
                          </span>
                        <h6 class="font-size-14 mb-0">
                          Natureza da Operação
                          <i @click="redirecionarNatureza" class="bx bx-link-external align-middle me-3" style="cursor:pointer;" title="Acessar Naturezas"></i>
                        </h6>
                        <h6 class="text-success ms-auto"
                            style="cursor:pointer;"
                            title="Editar Natureza"
                            @click="showModalNatureza = true">
                          <i class="bx bx-pencil font-size-12 align-middle mx-1"/>
                          Editar
                        </h6>
                      </div>

                      <div class="row">
                        <div class="row text-muted mt-1 mb-2">
                          <div class="col-12">
                            <h6>Descrição:</h6>
                            <h6 v-if="naturezaData?.descricao">{{ naturezaData.descricao }}</h6>
                          </div>
                        </div>
                      </div>
                    </div>

                    <hr class="mx-4" style="width: 1px;height: 50px;background-color: #000;border: none;margin: 0 10px;">

                    <div class="col-4">
                      <div class="d-flex align-items-baseline mb-2">
                          <span class="text-warning font-size-20 me-2">
                            <i class="mdi mdi-cash-multiple"></i>
                          </span>
                        <h5 class="font-size-14 mb-0">
                          Informações do Financeiro
                        </h5>
                        <div class="ms-2">
                          <h6>( Financ. ID: {{  this.pedidoData.financ_id ?? '' }} )</h6>
                        </div>
                        <h6 class="text-warning ms-auto"
                            style="cursor:pointer;"
                            title="Editar Financeiro"
                            @click="editarFinanceiro">
                          <i class="bx bx-pencil font-size-12 align-middle mx-1"/>
                          Editar
                        </h6>
                      </div>

                      <div class="row text-muted mt-1 mb-2">
                        <div class="col-3">
                          <h6>Forma Pgto:</h6>
                          <h6 class="d-flex">
                            <span>{{ pedidoData?.formapgto}} -</span>
                            <span class="ms-1" v-if="formaPgtoData">{{ formaPgtoData?.descricao }}</span>
                          </h6>
                        </div>

                        <div class="col-3">
                          <h6>Condição Pgto:</h6>
                          <h4>
                            <h6>{{ pedidoData?.condpgto }}: {{ condPgtoData ? condPgtoData?.descricao : '-' }}</h6>
                          </h4>
                        </div>

                        <div class="col-3">
                          <h6>Banco:</h6>
                          <h6 v-if="contaData">{{ contaData?.banco}} - {{ contaData?.descricao}}</h6>
                        </div>

                        <div class="col-3">
                          <h6 title="Consultar dias úteis">Cons. Dia Útil:</h6>
                          <h6>{{ pedidoData?.consutil === true ? "Sim" : "Não"}}</h6>
                        </div>
                      </div>
                    </div>
                  </div>


                  <div class="col-8 mt-3">
                    <div class="d-flex ">
                      <h6>Observações:</h6>
                      <h6 class="text-info ms-4"
                          style="cursor:pointer;"
                          title="Editar Observações"
                          @click="alteraObs">
                        <i class="bx bx-pencil font-size-12 align-middle mx-1"/>
                        Editar Observações
                      </h6>
                    </div>

                    <div class="border p-3 rounded ">
                      <span class="text-muted" style="white-space: pre-line;" v-if="pedidoData?.obsnf">{{ this.pedidoData.obsnf }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row col-12">
                <div class="col-12">
                  <div class="border p-3 rounded mt-1" style="min-height: 350px">
                    <b-tabs pills justified content-class="p-3 text-muted" v-if="!loadingPedido">
                      <b-tab active class="border-0">
                        <template v-slot:title>
                        <span class="d-inline-block d-sm-none">
                          <i class="fas fa-home"></i>
                        </span>
                          <span class="d-none d-sm-inline-block">PRODUTOS ({{ pedItensData.length }})</span>
                        </template>


                        <div class="table-responsive"  style="max-height: 400px; overflow-y: auto;">
                          <table class="table table-nowrap table-centered mb-0 align-middle">
                            <thead class="table-light">
                            <tr>
                              <th scope="col" style="position: sticky; top: 0;">Produto</th>
                              <th scope="col" style="position: sticky; top: 0; min-width: 20ch">Descrição</th>
                              <th scope="col" class="text-center" style="position: sticky; top: 0">CFOP</th>
                              <th scope="col" class="text-center" style="position: sticky; top: 0">NCM</th>
                              <th scope="col" class="text-center" style="position: sticky; top: 0">Qtd.</th>
                              <th scope="col" class="text-center" style="position: sticky; top: 0">Valor Uni. (R$)</th>
                              <th scope="col" class="text-center" style="position: sticky; top: 0">Valor Total (R$)</th>
                              <th scope="col" class="text-center" style="position: sticky; top: 0">Peso Total(Kg)</th>
                              <th scope="col" class="text-center" style="position: sticky; top: 0">Cubagem Total(m³)</th>
                            </tr>
                            </thead>
                            <tbody>

                            <template v-if="pedItensData?.length > 0">
                              <tr v-for="data in pedItensData" :key="data.id">

                                <td style="background-color: white">
                                  <router-link :to="`/produto/editar/${data.produto_id}`" target="_blank">
                                    <h5 class="text-muted mb-0">{{ data.produto }} </h5>
                                  </router-link>
                                </td>
                                <td style="background-color: white">
                                  <router-link :to="`/produto/editar/${data.produto_id}`" target="_blank">
                                    <span class="text text-wrap">{{ data.descprod }}</span>
                                  </router-link>
                                </td>
                                <td style="background-color: white">
                                  <div class="text-muted text-center"> {{ naturezaData.cfopicms }}</div>
                                </td>
                                <td style="background-color: white">
                                  <div class="text-muted text-center">{{ data.ncm }}</div>
                                </td>
                                <td style="background-color: white">
                                  <div class="text-muted text-center">{{ formatInteger(data.qtd) }}</div>
                                </td>
                                <td style="background-color: white">
                                  <h5 class="font-size-14 mb-1 text-center">{{ `R$${formatDecimal(data.vlrunitliq)}` }}</h5>
                                  <div class="text-muted text-center">{{ `R$${formatDecimal(data.vlrtotalliq)}` }}</div>
                                </td>
                                <td style="background-color: white">
                                  <h5 class="font-size-14 mb-1 text-center">{{ `R$${formatDecimal(data.vlrtotalliq)}` }}</h5>
                                </td>
                                <td style="background-color: white">
                                  <h5 class="font-size-14 mb-1 text-center">{{ formatDecimal(data.peso) }}</h5>
                                </td>
                                <td style="background-color: white">
                                  <h5 class="font-size-14 mb-1 text-center">{{ formatBigDecimal(data.cubtot) }}</h5>
                                </td>
                              </tr>

                            </template>

                            <template v-else>
                              <tr>
                                <td colspan="9">
                                  <b-alert show variant="warning">Nenhuma informação de produto ainda!</b-alert>
                                </td>

                              </tr>
                            </template>
                            </tbody>
                          </table>
                        </div>


                      </b-tab>

                      <b-tab class="border-0">
                        <template v-slot:title>
                        <span class="d-inline-block d-sm-none">
                          <i class="fas fa-home"></i>
                        </span>
                          <span class="d-none d-sm-inline-block">NF-e(Fiscal Itens)</span>
                        </template>

                        <div class="table-responsive"  style="max-height: 400px; overflow-y: auto;">
                          <table class="table table-nowrap table-centered mb-0 align-middle">
                            <thead class="table-light">
                            <tr>
                              <th scope="col" style="position: sticky; top: 0;">Produto</th>
                              <th scope="col" style="position: sticky; top: 0; min-width: 20ch">Descrição</th>
                              <th scope="col" class="text-center" style="position: sticky; top: 0">GTIN/EAN</th>
                              <th scope="col" class="text-center" style="position: sticky; top: 0">NCM</th>
                              <th scope="col" class="text-center" style="position: sticky; top: 0">Qtd.</th>
                              <th scope="col" class="text-center" style="position: sticky; top: 0">Unid.</th>
                              <th scope="col" class="text-center" style="position: sticky; top: 0">Valor Uni. (R$)</th>
                              <th scope="col" class="text-center" style="position: sticky; top: 0">CNOSN</th>
                              <th scope="col" class="text-center" style="position: sticky; top: 0">Cód. Trib. ICMS</th>
                              <th scope="col" class="text-center" style="position: sticky; top: 0">Aliq ICMS</th>
                              <th scope="col" class="text-center" style="position: sticky; top: 0">Cód. Trib. PIS</th>
                              <th scope="col" class="text-center" style="position: sticky; top: 0">Aliq. PIS</th>
                              <th scope="col" class="text-center" style="position: sticky; top: 0">Cód. Trib. COFINS</th>
                              <th scope="col" class="text-center" style="position: sticky; top: 0">Aliq. COFINS</th>
                            </tr>
                            </thead>

                            <tbody>


                              <template v-if="nota_item.length > 0">
                                <tr v-for="data in nota_item" :key="data.id">
                                  <td style="background-color: white">
                                    <div class="text-muted text-center">{{ data.cprod }}</div>
                                  </td>
                                  <td style="background-color: white">
                                    <span class="text text-wrap">{{ data.xprod }}</span>
                                  </td>
                                  <td style="background-color: white">
                                    <div class="text-muted text-center">{{ data.cean }}</div>
                                  </td>
                                  <td style="background-color: white">
                                    <div class="text-muted text-center">{{ data.ncm }}</div>
                                  </td>
                                  <td style="background-color: white">
                                    <div class="text-muted text-center">{{ formatInteger(data.qtrib) }}</div>
                                  </td>
                                  <td style="background-color: white">
                                    <div class="text-muted text-center">{{ data.ucom }}</div>
                                  </td>
                                  <td style="background-color: white">
                                    <h5 class="font-size-14 mb-1 text-center">R${{ `R$${formatDecimal(data.vuntrib)}` }}</h5>
                                    <div class="text-muted text-center">R${{ `R$${formatDecimal(data.vtottrib)}` }}</div>
                                  </td>
                                  <td style="background-color: white">
                                    <div class="text-muted text-center">{{ data.csosn }}</div>
                                  </td>
                                  <td style="background-color: white">
                                    <div class="text-muted text-center">{{ data.cst_icms }}</div>
                                  </td>
                                  <td style="background-color: white">
                                    <div class="text-muted text-center">{{ data.picms > 0 ? `${data.picms}%` : '-'  }}</div>
                                  </td>
                                  <td style="background-color: white">
                                    <div class="text-muted text-center">{{ data.cst_pis }}</div>
                                  </td>
                                  <td style="background-color: white">
                                    <div class="text-muted text-center">{{ data.ppis > 0 ? `${data.ppis}%` : '-'  }}</div>
                                  </td>
                                  <td style="background-color: white">
                                    <div class="text-muted text-center">{{ data.cst_cof }}</div>
                                  </td>
                                  <td style="background-color: white">
                                    <div class="text-muted text-center">{{ data.pcofins > 0 ? `${data.pcofins}%` : '-'  }}</div>
                                  </td>
                                </tr>
                              </template>

                              <template v-else>
                                <tr>
                                  <td colspan="14">
                                    <b-alert show variant="warning">Nenhuma informação de nota ainda!</b-alert>
                                  </td>

                                </tr>
                              </template>

                            </tbody>
                          </table>
                        </div>
                      </b-tab>

                      <b-tab>
                        <template v-slot:title>
                        <span class="d-inline-block d-sm-none">
                          <i class="far fa-user"></i>
                        </span>
                          <span class="d-none d-sm-inline-block">FINANCEIRO</span>
                        </template>


                        <div class="table-responsive">
                          <table class="table table-nowrap table-centered mb-0 align-middle">
                            <thead>
                            <tr>
                              <th scope="col">ID</th>
                              <th scope="col">Código</th>
                              <th scope="col">Parcelas</th>
                              <th scope="col">Emissão</th>
                              <th scope="col" class="text-end">Status</th>
                              <th scope="col" class="text-end">Baixa</th>
                              <th scope="col" class="text-end">Valor</th>
                              <th scope="col" class="text-end">Valor Em Aberto</th>
                              <th scope="col" class="text-end">Categoria</th>
                            </tr>
                            </thead>
                            <tbody>

                            <template v-if="financeirosData">
                              <tr v-for="data in financeirosData" :key="data.id">
                                <th scope="row" style="max-width: 20%;">
                                  <router-link :to="`/creceber/editar/${data.id}`" target="_blank">
                                    <h5 class="text-muted mb-0">{{ data.id }} </h5>
                                    <p></p>
                                  </router-link>
                                </th>

                                <th scope="row" style="max-width: 20%;">
                                  <router-link :to="`/creceber/editar/${data.id}`" target="_blank">
                                    <span class="text text-wrap">{{ data.codigo }}</span>
                                    <p></p>
                                  </router-link>
                                </th>

                                <td>
                                  <div class="text-muted">{{ data.qtdparc }}</div>
                                </td>

                                <td>
                                  <div class="text-muted">{{ formatDate(data.emissao) }}</div>
                                </td>

                                <td>
                                  <div class="text-muted text-end">{{ data.status }}</div>
                                </td>

                                <td>
                                  <div class="text-muted text-end">{{ data.stsbaixa }}</div>
                                </td>

                                <td>
                                  <h5 class="font-size-14 mb-1 text-end">{{ formatDecimal(data.valorori) }}</h5>
                                </td>
                                <td>
                                  <h5 class="font-size-14 mb-1 text-end">{{ formatDecimal(data.valorabe) }}</h5>
                                </td>

                                <td>
                                  <h5 class="font-size-14 mb-1 text-end">{{ data.categoria ?? '-' }}</h5>
                                </td>
                              </tr>
                            </template>

                            <template v-else>
                              <tr>
                                <td colspan="8">
                                  <b-alert show variant="warning">Nenhuma informação financeira ainda!</b-alert>
                                </td>
                              </tr>
                            </template>

                            </tbody>
                          </table>
                        </div>
                      </b-tab>

                      <b-tab>
                        <template v-slot:title>
                        <span class="d-inline-block d-sm-none">
                          <i class="far fa-user"></i>
                        </span>
                          <span class="d-none d-sm-inline-block">ESCRITURAÇÃO</span>
                        </template>


                          <span>
                            <b-alert show variant="warning">Nenhuma informação de escrituração ainda!</b-alert>
                          </span>

                      </b-tab>
                    </b-tabs>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>


    <b-modal title="Enviar E-mail Nota Fiscal Eletrônica"
             v-model="showModalEnviarXML"
             hide-footer>
      <div>


        <div class="row">
          <div class="col-md-12">
            <div class="mb-3">
              <label for="emaienvxml">Endereço de e-mail cliente</label>
              <input
                  id="emaienvxml"
                  v-model="clienteData.email"
                  type="email"
                  :disabled="true"
                  class="form-control"
                  placeholder="Endereço de e-mail cliente"/>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-md-12">
            <div class="mb-3">
              <label for="emailadic">Enviar a outro endereço de e-mail</label>
              <input
                  id="emailadic"
                  v-model="emailAdicEnviarXml"
                  type="email"
                  class="form-control"
                  placeholder="Endereço de e-mail em cópia"/>
            </div>
          </div>
        </div>

        <div class="row">


          <div class="col-md-6">
            <div class="mb-3 ">
              <h5 class="font-size-14">Enviar a Cliente</h5>
              <b-form-checkbox
                  switch size="lg"
                  value="A"
                  unchecked-value="I"
                  v-model="envCliEnviarXml">
                {{ envCliEnviarXml === 'A' ? 'Ativo' : 'Inativo' }}
              </b-form-checkbox>
            </div>
          </div>


          <div class="col-md-6">
            <div class="mb-3 align-items-end align-content-end float-end">
              <h5 class="font-size-14">Enviar danfe</h5>
              <b-form-checkbox
                  switch size="lg"
                  value="A"
                  unchecked-value="I"
                  v-model="envDanfeEnviarXml">
                {{ envDanfeEnviarXml === 'A' ? 'Ativo' : 'Inativo' }}
              </b-form-checkbox>
            </div>
          </div>

        </div>

        <div class="row">
          <div class="text-end mt-5">
            <b-button variant="light" @click="showModalEnviarXML = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Fechar
            </b-button>

            <b-button variant="success" class="ms-1" @click="emailXML">
              <i class="bx bx-copy font-size-16 align-middle me-2"></i>
              Enviar
            </b-button>

          </div>
        </div>
      </div>
    </b-modal>


    <b-modal size="lg"
             title="Visualizar XML"
             v-model="showModalXML"
             hide-footer>
      <div>
        <div class="row">
          <div class="content">
            <div>XML-content:
              <pre>{{ xmlContent }}</pre>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="text-end mt-5">
            <b-button variant="light" @click="showModalXML = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Fechar
            </b-button>

            <!--            <b-button  variant="success" class="ms-1" @click="copiarXML">-->
            <!--              <i class="bx bx-copy font-size-16 align-middle me-2"></i>-->
            <!--              Copiar Objeto-->
            <!--            </b-button>-->

          </div>
        </div>
      </div>
    </b-modal>


    <b-modal size="xl"
             title="Integração Corpem"
             v-model="showModalMediaJson"
             hide-footer>
      <div v-if="mediaJsonPed && mediaJsonPed.id">
        <div class="row">

          <div class="col-md-12">
            <label for="objenvio" class="col-form-label col-lg-2">
              Objeto Enviado
            </label>
            <div class="col-lg-12">
                  <textarea
                      id="objenvio"
                      class="form-control"
                      rows="10"
                      v-model="mediaJsonPedEnvio"
                      :disabled="true"
                      placeholder="Objeto enviado"
                  ></textarea>
            </div>
          </div>

        </div>

        <div class="row">

          <div class="col-md-12">
            <label for="objretorno" class="col-form-label col-lg-2">
              Objeto de Retorno
            </label>
            <div class="col-lg-12">
                  <textarea
                      id="objretorno"
                      class="form-control"
                      rows="10"
                      v-model="mediaJsonPedRet"
                      :disabled="true"
                      placeholder="Objeto de retorno"
                  ></textarea>
            </div>
          </div>

        </div>


        <div class="row">
          <div class="text-end mt-5">
            <b-button variant="light" @click="showModalMediaJson = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Fechar
            </b-button>

            <!--            <b-button  variant="success" class="ms-1" @click="copiarXML">-->
            <!--              <i class="bx bx-copy font-size-16 align-middle me-2"></i>-->
            <!--              Copiar XML-->
            <!--            </b-button>-->

          </div>
        </div>
      </div>
    </b-modal>


    <!--    <b-modal title="Detalhes Forma de Pagamento" v-model="showModalFormaPgto" centered hide-footer>-->
    <!--      <div class="col-md-12">-->
    <!--        <div class="mb-3">-->
    <!--          <span>Selecionar Nova Forma de Pagamento</span>-->

    <!--          <multiselect id="formapgto"-->
    <!--                       @search-change="pesqFormaPgto"-->
    <!--                       @select="escolheuFormaPgto"-->
    <!--                       v-model="pedidoData.formapgto"-->
    <!--                       placeholder="Pesquisar forma de pagamento"-->
    <!--                       :options="dtListPesqFormaPgto"-->
    <!--                       :searchable="true"-->
    <!--                       label="descricao"-->
    <!--                       track-by="descricao"-->
    <!--                       value-prop="codigo">-->
    <!--            <template #option="slotProps">-->
    <!--              <div class="row">-->
    <!--                <div>-->
    <!--                  <span class="text-info">-->
    <!--                    {{ slotProps.option.codigo }}-->
    <!--                  </span>-->
    <!--                  <span class="mx-4" >-->

    <!--                  </span>-->
    <!--                </div>-->
    <!--                <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>-->
    <!--                <span class="mx-4" >-->
    <!--                </span>-->
    <!--                <span class="mx-4" >-->
    <!--                </span>-->
    <!--                <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>-->

    <!--              </div>-->
    <!--            </template>-->
    <!--          </multiselect>-->

    <!--        </div>-->
    <!--      </div>-->

    <!--      <div class="row" v-if="loadingFormaPgto">-->
    <!--        <div class="col-12 text-center">-->
    <!--          <b-spinner type="grow"-->
    <!--                     class="m-6 mx-2"-->
    <!--                     variant="secondary"-->
    <!--                     role="status">-->
    <!--          </b-spinner>-->
    <!--          <b-spinner type="grow"-->
    <!--                     class="m-6 mx-2"-->
    <!--                     variant="secondary"-->
    <!--                     role="status">-->
    <!--          </b-spinner>-->
    <!--          <b-spinner type="grow"-->
    <!--                     class="m-6 mx-2"-->
    <!--                     variant="secondary"-->
    <!--                     role="status">-->
    <!--          </b-spinner>-->
    <!--        </div>-->
    <!--      </div>-->


    <!--      <div v-if="!loadingFormaPgto && formaPgtoData">-->
    <!--        <p class="mb-2">-->
    <!--          Forma de Pagamento Atual-->
    <!--        </p>-->
    <!--        <router-link :to="`/tiposopera/list`" target="_blank" >-->
    <!--          <p class="mb-2">-->
    <!--            Código:-->
    <!--            <span class="text-primary"> {{ formaPgtoData.codigo }} </span>-->
    <!--          </p>-->

    <!--          <p class="mb-2" >-->
    <!--            Descrição:-->
    <!--            <span class="text-primary"> {{ formaPgtoData.descricao }}  </span>-->
    <!--          </p>-->
    <!--        </router-link>-->

    <!--        <div class="table-responsive" v-if="ultPedsData">-->
    <!--          <table class="table table-centered table-nowrap">-->
    <!--            <thead>-->
    <!--            <tr>-->
    <!--              <th scope="col">Últimos Pedidos</th>-->
    <!--              <th scope="col" class="text-end">Data</th>-->
    <!--              <th scope="col" class="text-end">Valor (R$)</th>-->
    <!--            </tr>-->
    <!--            </thead>-->
    <!--            <tbody>-->
    <!--            <tr v-for="data in ultPedsData" :key="data.id">-->
    <!--              <td>-->
    <!--                <router-link :to="`/orcamento/editar/${data.id}`" target="_blank">-->
    <!--                  <div>-->
    <!--                    <h5 class="text-truncate font-size-14">-->
    <!--                      {{ data.codigo }}-->
    <!--                    </h5>-->
    <!--                  </div>-->
    <!--                </router-link>-->
    <!--              </td>-->
    <!--              <td class="text-end">{{ formatDateTime(data.created_at) }}</td>-->
    <!--              <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>-->
    <!--            </tr>-->
    <!--            <tr>-->
    <!--              <td colspan="2">-->
    <!--                <h6 class="m-0 text-end">Valor Total Pedidos:</h6>-->
    <!--              </td>-->
    <!--              <td class="text-end">R$ {{ formatDecimal(somaPedidosCli) }}</td>-->
    <!--            </tr>-->
    <!--            <tr>-->
    <!--              <td colspan="2">-->
    <!--                <h6 class="m-0 font-size-14  text-end">Ticket Médio:</h6>-->
    <!--              </td>-->
    <!--              <td class="font-size-14 text-end">R$ {{ formatDecimal(somaPedidosCli / 3) }}</td>-->
    <!--            </tr>-->
    <!--            </tbody>-->
    <!--          </table>-->
    <!--        </div>-->
    <!--        <div class="text-end mt-5">-->
    <!--          <b-button variant="light" @click="showModalFormaPgto = false">-->
    <!--            <i class="bx bx-block font-size-16 align-middle me-2"></i>-->
    <!--            Cancelar-->
    <!--          </b-button>-->
    <!--          <b-button type="submit" variant="success" class="ms-1" @click="confirmarFormaPgto">-->
    <!--            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>-->
    <!--            Confirmar-->
    <!--          </b-button>-->
    <!--        </div>-->
    <!--      </div>-->

    <!--    </b-modal>-->


    <b-modal title="Detalhes Pagamento" v-model="showModalCondPgto" centered hide-footer>

      <div class="col-md-12 mt-2">
        <div class="mb-3">
          <span>Selecionar Nova Forma de Pagamento</span>

          <multiselect id="formapgto"
                       @search-change="pesqFormaPgto"
                       @select="escolheuFormaPgto"
                       v-model="pedidoData.formapgto"
                       placeholder="Pesquisar forma de pagamento"
                       :options="dtListPesqFormaPgto"
                       :searchable="true"
                       label="descricao"
                       track-by="descricao"
                       value-prop="codigo">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4">

                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                <span class="mx-4">
                </span>
                <span class="mx-4">
                </span>
                <div class="align-items-end text-end align-content-end">{{
                    formatDateTime(slotProps.option.created_at)
                  }}
                </div>

              </div>
            </template>
          </multiselect>

        </div>
      </div>

      <div class="col-md-12 mt-2">
        <div class="mb-3">
          <span>Selecionar Nova Condição de Pagamento</span>

          <multiselect id="condpgto"
                       @search-change="pesqCondPgto"
                       @select="escolheuCondPgto"
                       v-model="pedidoData.condpgto"
                       placeholder="Pesquisar condição de pagamento"
                       :options="dtListPesqCondPgto"
                       :searchable="true"
                       label="descricao"
                       track-by="descricao"
                       value-prop="codigo">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4">

                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>

                <span class="mx-4">

                </span>
                <span class="mx-4">

                  </span>
                <div class="align-items-end text-end align-content-end">{{
                    formatDateTime(slotProps.option.created_at)
                  }}
                </div>

              </div>
            </template>
          </multiselect>

        </div>
      </div>

      <div class="row" v-if="loadingFinanc">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>


      <div v-if="!loadingCondPgto && condPgtoData && formaPgtoData">


        <div class="mt-2">
          <p class="mb-2">
            Forma de Pagamento Atual
          </p>

          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ formaPgtoData.codigo }} </span>
          </p>

          <p class="mb-2">
            Descrição:
            <span class="text-primary"> {{ formaPgtoData.descricao }}  </span>
          </p>
        </div>


        <div class="mt-4">
          <p class="mb-2">
            Condição de Pagamento Atual
          </p>

          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ condPgtoData.codigo }} </span>
          </p>

          <p class="mb-2">
            Descrição:
            <span class="text-primary"> {{ condPgtoData.descricao }}  </span>
          </p>
        </div>


        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalCondPgto = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarCondPgto">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>


    <!--
        Pablo => Modal para cancelar uma nota
      -->
    <b-modal size="lg" title="Cancelamento de Nota Fiscal" v-model="showModalCancFocusNfe" centered hide-footer>
      <div class="row" id="div-principal">
        <div class="row" id="div-card">
          <div class="card-body d-flex" id="div-car-body">
            <form class="needs-validation">
              <div class="row justify-content-center">
                <div class="col-sm-6">
                  <label for="justificativa" class="text-center">Limite entre 15 a 255 caracteres</label>
                  <br>
                  <textarea v-model="justificativaCanc"
                            name="justificativa"
                            id="justificativa"
                            class="form-control"
                            cols="70"
                            rows="10"
                            placeholder="Justificativa"
                            minlength="15"
                            maxlength="255">
                  </textarea>
                </div>
              </div>

              <div class="row">
                <div class="text-end mt-5">
                  <b-button variant="light" @click="showModalCancFocusNfe = false">
                    <i class="bx bx-block font-size-16 align-middle me-2"></i>
                    Voltar
                  </b-button>
                  <b-button type="button" variant="success" class="ms-1" @click="confirmarCancFocusNfe()">
                    <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                    Confirmar
                  </b-button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </b-modal>

    <!--
      Pablo => Modal para envio de carta de correção
    -->
    <b-modal size="lg" title="Carta de correção de Nota Fiscal" v-model="showModalCorrFocusNfe" centered hide-footer>
      <div class="row" id="div-principal">
        <div class="row" id="div-card">
          <div class="card-body d-flex" id="div-car-body">
            <form class="needs-validation">
              <div class="row justify-content-center">
                <div class="col-sm-6">
                  <label for="correcao" class="text-center">Limite entre 15 a 1000 caracteres</label>
                  <br>
                  <textarea v-model="justificativaCorr"
                            name="correcao"
                            id="correcao"
                            class="form-control"
                            cols="70"
                            rows="10"
                            placeholder="Correção"
                            minlength="15"
                            maxlength="1000">
                  </textarea>
                </div>
              </div>

              <div class="row justify-content-center">
                <div class="text-end mt-5">
                  <b-button variant="light" @click="showModalCorrFocusNfe = false">
                    <i class="bx bx-block font-size-16 align-middle me-2"></i>
                    Voltar
                  </b-button>
                  <b-button type="button" variant="success" class="ms-1" @click="confirmarCorrFocusNfe">
                    <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                    Confirmar
                  </b-button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </b-modal>

    <!--
      Pablo => Modal para confirmação do tipo de pesquisa
    -->
    <b-modal
        v-model="tipoConsultaFocusNFe"
        id="modal-center"
        centered
        title="Escolha o tipo de consulta desejado"
        title-class="font-18"
        hide-footer
    >
      <p>Qual tipo de consulta você deseja realizar?</p>

      <div class="text-center">
        <!--<div class=" d-inline" :style="{'margin-right': '10px'}">
          <b-button variant="secondary" @click="consultarFocusNFe(0)">Simplificada</b-button>
        </div>-->
        <div class=" d-inline" :style="{'margin-left': '10px'}">
          <b-button variant="secondary" @click="consultarFocusNFe(1, 1)">Completa</b-button>
        </div>
      </div>
    </b-modal>


    <!--
      Pablo => Modal para retorno simplificado modalConsultaSimplificada | retornoConsultaFocusNFe
    -->
    <b-modal
        v-model="modalConsultaSimplificada"
        id="modal-xl"
        size="xl"
        title="Status da Nota fiscal"
        title-class="font-18"
        hide-footer
        @hide="atualizaPagina"
    >
      <table class="table">
        <tbody>
        <template v-for="(value, key) in retornoConsultaFocusNFe" :key="key">
          <tr>
            <td>{{ key }}</td>
            <td>
              <template v-if="typeof value === 'object'">
                <table class="table">
                  <tbody>
                  <tr v-for="(subValue, subKey) in value" :key="subKey">
                    <td>{{ subKey }}</td>
                    <td>{{ subValue }}</td>
                  </tr>
                  </tbody>
                </table>
              </template>
              <template v-else>
                {{ value }}
              </template>
            </td>
          </tr>
        </template>
        </tbody>
      </table>
    </b-modal>

    <!--
      Pablo => Modal para retorno do envio/reenvio da nota fiscal | modalRetornoEnvioFocusnfe
    -->
    <b-modal
        v-model="modalRetornoEnvioFocusnfe"
        id="modal-xl"
        size="xl"
        title="Status da Nota fiscal"
        title-class="font-18"
        hide-footer
        @hide="carregarDados"
    >


      <table class="table">
        <tbody>
        <tr v-for="(value, key) in retornoConsultaFocusNFe" :key="key">
          <td>{{ key }}</td>
          <td>{{ value }}</td>
        </tr>
        <!-- Verifica se há erros -->
        <tr v-if="retornoConsultaFocusNFe.erros">
          <td colspan="2">
            <table class="sub-table">
              <tbody>
              <tr v-for="(erro, index) in retornoConsultaFocusNFe.erros" :key="index">
                <td>{{ erro.mensagem }}</td>
                <td>{{ erro.campo }}</td>
              </tr>
              </tbody>
            </table>
          </td>
        </tr>
        </tbody>
      </table>
    </b-modal>

    <b-modal
        v-model="modalErros"
        id="modal-xl"
        size="xl"
        title="Oops... Algo deu errado!"
        title-class="font-18"
        hide-footer
        @hide="atualizaPagina"
    >
      <table class="table">
        <tbody>
        <tr v-for="(value, key) in retornoConsultaFocusNFe" :key="key">
          <td>{{ key }}</td>
          <td>{{ value }}</td>
        </tr>
        </tbody>
      </table>

      <div class="d-flex justify-content-center">
        <b-button variant="success" @click="modalErros = false">Fechar</b-button>
      </div>
    </b-modal>

    <b-modal
        v-model="showEspelhoNota"
        id="modal-xl"
        size="xl"
        title="Espelho da NF-e Venda"
        title-class="font-18"
        hide-footer
    >
      <div class="card">
        <div class="card-body">
          <b-form>
            <b-form-group
                class="mb-3"
                label="Natureza da operação [Tag natOp]"
                label-for="nota_ide.natop"
            >
              <b-form-input
                  id="nota_ide.natop"
                  type="text"
                  v-model="nota_ide.natop"
                  readonly
              ></b-form-input>
            </b-form-group>

            <br>
            <div class="row">
              <h4>Informações gerais da nota</h4>
              <div class="col-md-2">
                <b-form-group
                    class="mb-3"
                    label="valor"
                    label-for="nota_ide.valor"
                >
                  <b-form-input
                      id="nota_ide.valor"
                      type="text"
                      v-model="nota_ide.valor"
                      readonly
                  ></b-form-input>
                </b-form-group>
              </div>


              <div class="col-md-2">
                <b-form-group
                    class="mb-3"
                    label="Data emissão"
                    label-for="nota_ide.dhemi"
                >
                  <b-form-input
                      id="nota_ide.dhemi"
                      type="text"
                      v-model="nota_ide.dhemi"
                      readonly
                  ></b-form-input>
                </b-form-group>
              </div>


              <div class="col-md-1">
                <b-form-group
                    class="mb-3"
                    label="Cód. UF"
                    label-for="nota_ide.cuf"
                >
                  <b-form-input
                      id="nota_ide.cuf"
                      type="text"
                      v-model="nota_ide.cuf"
                      readonly
                  ></b-form-input>
                </b-form-group>
              </div>


              <div class="col-md-1">
                <b-form-group
                    class="mb-3"
                    label="[tpNF]"
                    title="Código referente ao tipo da nota"
                    label-for="nota_ide.tpnf"
                >
                  <b-form-input
                      id="nota_ide.tpnf"
                      type="text"
                      v-model="nota_ide.tpnf"
                      readonly
                  ></b-form-input>
                </b-form-group>
              </div>


              <div class="col-md-3">
                <b-form-group
                    class="mb-3"
                    label="Local destino [idDest]"
                    title="Identificador de local de destino da operação"
                    label-for="nota_ide.iddest"
                >

                  <select
                      id="nota_ide.iddest"
                      v-model="nota_ide.iddest"
                      class="form-control">
                    <option value="1">[1] Operação interna</option>
                    <option value="2">[2] Operação interestadual</option>
                    <option value="3">[3] Operação com exterior</option>
                  </select>

                </b-form-group>
              </div>


              <div class="col-md-2">
                <b-form-group
                    class="mb-3"
                    label="Cód. Município"
                    title="Código referente ao município"
                    label-for="nota_ide.cmunfg"
                >
                  <b-form-input
                      id="nota_ide.cmunfg"
                      type="text"
                      v-model="nota_ide.cmunfg"
                      readonly
                  ></b-form-input>
                </b-form-group>
              </div>


              <div class="col-md-1">
                <b-form-group
                    class="mb-3"
                    label="[finNFe]"
                    title="Código de finalidade da nota fiscal."
                    label-for="note_ide.finnfe"
                >
                  <b-form-input
                      id="note_ide.finnfe"
                      type="text"
                      readonly
                      v-model="nota_ide.finnfe"
                  ></b-form-input>
                </b-form-group>
              </div>


              <div class="col-md-3">
                <b-form-group
                    class="mb-3"
                    label="[indFinal]"
                    title="Indica operação com consumidor final"
                    label-for="nota_ide.indfinal"
                >

                  <select
                      id="nota_ide.indfinal"
                      v-model="nota_ide.indfinal"
                      class="form-control">
                    <option value="0">[0] Normal</option>
                    <option value="1">[1] Consumidor final</option>
                  </select>
                </b-form-group>
              </div>


              <div class="col-md-4">
                <b-form-group
                    class="mb-3"
                    label="Presença [indPres]"
                    title="Indicador de presença do comprador no estabelecimento comercial no momento da operação"
                    label-for="nota_ide.indpres"
                >
                  <select
                      id="nota_ide.indpres"
                      v-model="nota_ide.indpres"
                      class="form-control">
                    <option value="0">[0] Não se aplica (por exemplo, para a Nota Fiscal complementar ou de ajuste)
                    </option>
                    <option value="1">[1] Operação presencial</option>
                    <option value="2">[2] Operação não presencial, pela Internet</option>
                    <option value="3">[3] Operação não presencial, Teleatendimento</option>
                    <option value="4">[4] NFC-e em operação com entrega em domicílio</option>
                    <option value="5">[5] Operação presencial, fora do estabelecimento</option>
                    <option value="9">[9] Operação não presencial, outros</option>
                  </select>
                </b-form-group>
              </div>
            </div>

            <br>
            <hr>
            <div class="row">
              <h4>Informações do Emissor</h4>
              <div class="col-md-5">
                <b-form-group
                    class="mb-3"
                    label="valor"
                    label-for="nota_emit.xnome"
                >
                  <b-form-input
                      id="nota_emit.xnome"
                      type="text"
                      v-model="nota_emit.xnome"
                      readonly
                  ></b-form-input>
                </b-form-group>
              </div>


              <div class="col-md-2">
                <b-form-group
                    class="mb-3"
                    label="CNPJ"
                    label-for="nota_emit.cnpj"
                >
                  <b-form-input
                      id="nota_emit.cnpj"
                      type="text"
                      v-model="nota_emit.cnpj"
                      readonly
                  ></b-form-input>
                </b-form-group>
              </div>


              <div class="col-md-2">
                <b-form-group
                    class="mb-3"
                    label="IE"
                    label-for="nota_emit.ie"
                >
                  <b-form-input
                      id="nota_emit.ie"
                      type="text"
                      v-model="nota_emit.ie"
                      readonly
                  ></b-form-input>
                </b-form-group>
              </div>


              <div class="col-md-3">
                <b-form-group
                    class="mb-3"
                    label="Cód tributário"
                    label-for="nota_emit.crt"
                >
                  <select
                      id="nota_emit.crt"
                      v-model="nota_emit.crt"
                      class="form-control"
                      readonly
                  >
                    <option value="1">[1] Simples nacional</option>
                    <option value="2">[2] Simples nacional - excesso de sublimite de receita bruta</option>
                    <option value="3">[3] Regime normal</option>
                  </select>
                </b-form-group>
              </div>


              <div class="col-md-4">
                <b-form-group
                    class="mb-3"
                    label="Logradouro"
                    label-for="nota_emit.xlgr"
                >
                  <b-form-input
                      id="nota_emit.xlgr"
                      type="text"
                      v-model="nota_emit.xlgr"
                      readonly
                  ></b-form-input>
                </b-form-group>
              </div>


              <div class="col-md-3">
                <b-form-group
                    class="mb-3"
                    label="Cidade"
                    label-for="nota_emit.xmun"
                >
                  <b-form-input
                      id="nota_emit.xmun"
                      type="text"
                      v-model="nota_emit.xmun"
                      readonly
                  ></b-form-input>
                </b-form-group>
              </div>


              <div class="col-md-3">
                <b-form-group
                    class="mb-3"
                    label="Bairro"
                    label-for="nota_emit.xbairro"
                >
                  <b-form-input
                      id="nota_emit.xbairro"
                      type="text"
                      v-model="nota_emit.xbairro"
                      readonly
                  ></b-form-input>
                </b-form-group>
              </div>


              <div class="col-md-1">
                <b-form-group
                    class="mb-3"
                    label="Número"
                    label-for="nota_emit.nro"
                >
                  <b-form-input
                      id="nota_emit.nro"
                      type="text"
                      v-model="nota_emit.nro"
                      readonly
                  ></b-form-input>
                </b-form-group>
              </div>


              <div class="col-md-1">
                <b-form-group
                    class="mb-3"
                    label="UF"
                    label-for="nota_emit.uf"
                >
                  <b-form-input
                      id="nota_emit.uf"
                      type="text"
                      v-model="nota_emit.uf"
                      readonly
                  ></b-form-input>
                </b-form-group>
              </div>


              <div class="col-md-2">
                <b-form-group
                    class="mb-3"
                    label="CEP"
                    label-for="nota_emit.cep"
                >
                  <b-form-input
                      id="nota_emit.cep"
                      type="text"
                      v-model="nota_emit.cep"
                      readonly
                  ></b-form-input>
                </b-form-group>
              </div>


              <div class="col-md-4">
                <b-form-group
                    class="mb-3"
                    label="Complemento"
                    label-for="nota_emit.xcpl"
                >
                  <b-form-input
                      id="nota_emit.xcpl"
                      type="text"
                      v-model="nota_emit.xcpl"
                      readonly
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>

            <br>
            <hr>
            <div class="row">
              <h4>Informações do Destinatário</h4>
              <div class="col-md-5">
                <b-form-group
                    class="mb-3"
                    label="valor"
                    label-for="nota_dest.xnome"
                >
                  <b-form-input
                      id="nota_dest.xnome"
                      type="text"
                      v-model="nota_dest.xnome"
                      readonly
                  ></b-form-input>
                </b-form-group>
              </div>


              <div class="col-md-2">
                <b-form-group
                    class="mb-3"
                    label="CNPJ"
                    label-for="nota_dest.cnpj"
                >
                  <b-form-input
                      id="nota_dest.cnpj"
                      type="text"
                      v-model="nota_dest.cnpj"
                      readonly
                  ></b-form-input>
                </b-form-group>
              </div>


              <div class="col-md-2">
                <b-form-group
                    class="mb-3"
                    label="IE"
                    label-for="nota_dest.ie"
                >
                  <b-form-input
                      id="nota_dest.ie"
                      type="text"
                      v-model="nota_dest.ie"
                      readonly
                  ></b-form-input>
                </b-form-group>
              </div>


              <div class="col-md-3">
                <b-form-group
                    class="mb-3"
                    label="Cidade"
                    label-for="nota_dest.xmun"
                >
                  <b-form-input
                      id="nota_dest.xmun"
                      type="text"
                      v-model="nota_dest.xmun"
                      readonly
                  ></b-form-input>
                </b-form-group>
              </div>


              <div class="col-md-3">
                <b-form-group
                    class="mb-3"
                    label="Bairro"
                    label-for="nota_dest.xbairro"
                >
                  <b-form-input
                      id="nota_dest.xbairro"
                      type="text"
                      v-model="nota_dest.xbairro"
                      readonly
                  ></b-form-input>
                </b-form-group>
              </div>


              <div class="col-md-4">
                <b-form-group
                    class="mb-3"
                    label="Logradouro"
                    label-for="nota_dest.xlgr"
                >
                  <b-form-input
                      id="nota_dest.xlgr"
                      type="text"
                      v-model="nota_dest.xlgr"
                      readonly
                  ></b-form-input>
                </b-form-group>
              </div>


              <div class="col-md-1">
                <b-form-group
                    class="mb-3"
                    label="Número"
                    label-for="nota_dest.nro"
                >
                  <b-form-input
                      id="nota_dest.nro"
                      type="text"
                      v-model="nota_dest.nro"
                      readonly
                  ></b-form-input>
                </b-form-group>
              </div>


              <div class="col-md-1">
                <b-form-group
                    class="mb-3"
                    label="UF"
                    label-for="nota_dest.uf"
                >
                  <b-form-input
                      id="nota_dest.uf"
                      type="text"
                      v-model="nota_dest.uf"
                      readonly
                  ></b-form-input>
                </b-form-group>
              </div>


              <div class="col-md-2">
                <b-form-group
                    class="mb-3"
                    label="CEP"
                    label-for="nota_dest.cep"
                >
                  <b-form-input
                      id="nota_dest.cep"
                      type="text"
                      v-model="nota_dest.cep"
                      readonly
                  ></b-form-input>
                </b-form-group>
              </div>


              <div class="col-md-4">
                <b-form-group
                    class="mb-3"
                    label="Complemento"
                    label-for="nota_dest.xcpl"
                >
                  <b-form-input
                      id="nota_dest.xcpl"
                      type="text"
                      v-model="nota_dest.xcpl"
                      readonly
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>

            <br>
            <hr>
            <h4>Informações dos itens da nota</h4>
            <div v-for="notaitem in nota_item" :key="notaitem.id">
              <div class="row">
                <div class="col-md-6">
                  <b-form-group
                      class="mb-3"
                      label="Produto"
                      label-for="notaitem.xprod"
                  >
                    <b-form-input
                        id="notaitem.xprod"
                        type="text"
                        v-model="notaitem.xprod"
                        readonly
                    ></b-form-input>
                  </b-form-group>
                </div>


                <div class="col-md-3">
                  <b-form-group
                      class="mb-3"
                      label="EAN"
                      label-for="notaitem.ceantrib"
                  >
                    <b-form-input
                        id="notaitem.ceantrib"
                        type="text"
                        v-model="notaitem.ceantrib"
                        readonly
                    ></b-form-input>
                  </b-form-group>
                </div>


                <div class="col-md-2">
                  <b-form-group
                      class="mb-3"
                      label="NCM"
                      label-for="notaitem.ncm"
                  >
                    <b-form-input
                        id="notaitem.ncm"
                        type="text"
                        v-model="notaitem.ncm"
                        readonly
                    ></b-form-input>
                  </b-form-group>
                </div>


                <div class="col-md-1">
                  <b-form-group
                      class="mb-3"
                      label="CFOP"
                      label-for="notaitem.cfop"
                  >
                    <b-form-input
                        id="notaitem.cfop"
                        type="text"
                        v-model="notaitem.cfop"
                    ></b-form-input>
                  </b-form-group>
                </div>


                <div class="col-md-1">
                  <b-form-group
                      class="mb-3"
                      label="Unidade"
                      label-for="notaitem.utrib"
                  >
                    <b-form-input
                        id="notaitem.utrib"
                        type="text"
                        v-model="notaitem.utrib"
                        readonly
                    ></b-form-input>
                  </b-form-group>
                </div>


                <div class="col-md-1">
                  <b-form-group
                      class="mb-3"
                      label="Qtdade"
                      label-for="notaitem.qtrib"
                  >
                    <b-form-input
                        id="notaitem.qtrib"
                        type="text"
                        v-model="notaitem.qtrib"
                        readonly
                    ></b-form-input>
                  </b-form-group>
                </div>


                <div class="col-md-2">
                  <b-form-group
                      class="mb-3"
                      label="Valor Un. R$"
                      label-for="notaitem.vuntrib"
                  >
                    <b-form-input
                        id="notaitem.vuntrib"
                        type="text"
                        v-model="notaitem.vuntrib"
                        readonly
                    ></b-form-input>
                  </b-form-group>
                </div>


                <div class="col-md-2">
                  <b-form-group
                      class="mb-3"
                      label="R$ Base cálculo"
                      label-for="notaitem.vbc"
                  >
                    <b-form-input
                        id="notaitem.vbc"
                        type="text"
                        v-model="notaitem.vbc"
                        readonly
                    ></b-form-input>
                  </b-form-group>
                </div>


                <div class="col-md-1">
                  <b-form-group
                      class="mb-3"
                      label="indTotal"
                      label-for="notaitem.indtot"
                  >
                    <b-form-input
                        id="notaitem.indtot"
                        type="text"
                        v-model="notaitem.indtot"
                        readonly
                    ></b-form-input>
                  </b-form-group>
                </div>


                <div class="col-md-5">
                  <b-form-group
                      class="mb-3"
                      label="origem"
                      label-for="notaitem.orig"
                  >
                    <select
                        id="notaitem.orig"
                        v-model="notaitem.orig"
                        class="form-control">
                      <option value="0">[0] nacional</option>
                      <option value="1">[1] estrangeira (importação direta)</option>
                      <option value="2">[2] estrangeira (adquirida no mercado interno)</option>
                      <option value="3">[3] nacional com mais de 40% de conteúdo estrangeiro</option>
                      <option value="4">[4] nacional produzida através de processos produtivos básicos</option>
                      <option value="5">[5] nacional com menos de 40% de conteúdo estrangeiro</option>
                      <option value="6">[6] estrangeira (importação direta) sem produto nacional similar</option>
                      <option value="7">[7] estrangeira (adquirida no mercado interno) sem produto nacional similar
                      </option>
                      <option value="8">[8] nacional, mercadoria ou bem com Conteúdo de Importação superior a 70%
                      </option>
                    </select>
                  </b-form-group>
                </div>


                <div class="col-md-6">
                  <b-form-group
                      class="mb-3"
                      label="Cód. ICMS"
                      label-for="notaitem.cst_icms"
                  >
                    <select id="notaitem.cst_icms" v-model="notaitem.cst_icms" class="form-control" required>
                      <option value="00">[00] tributada integralmente</option>
                      <option value="02">[02] tributação monofásica própria sobre combustíveis</option>
                      <option value="10">[10] tributada e com cobrança do ICMS por substituição tributária</option>
                      <option value="10_partilha">[10_partilha] tributada e com cobrança do ICMS por substituição
                        tributária. Operação interestadual para consumidor final com partilha do ICMS devido na operação
                        entre a UF de origem e a do destinatário, ou a UF definida na legislação. (Ex. UF da
                        concessionária de entrega do veículo)
                      </option>
                      <option value="15">[15] tributação monofásica própria e com responsabilidade pela retenção sobre
                        combustíveis
                      </option>
                      <option value="20">[20] tributada com redução de base de cálculo</option>
                      <option value="30">[30] isenta ou não tributada e com cobrança do ICMS por substituição
                        tributária
                      </option>
                      <option value="40">[40] isenta</option>
                      <option value="41">[41] não tributada</option>
                      <option value="41_st">[41_st] não tributada com ICMS ST devido para a UF de destino, nas operações
                        interestaduais de produtos que tiveram retenção antecipada de ICMS por ST na UF do remetente.
                        Repasse via Substituto Tributário.
                      </option>
                      <option value="50">[50] suspensão</option>
                      <option value="51">[51] diferimento (a exigência do preenchimento das informações do ICMS diferido
                        fica a critério de cada UF)
                      </option>
                      <option value="53">[53] tributação monofásica sobre combustíveis com recolhimento diferido
                      </option>
                      <option value="60">[60] cobrado anteriormente por substituição tributária</option>
                      <option value="60_st">[60_st] cobrado anteriormente por substituição tributária com ICMS ST devido
                        para a UF de destino, nas operações interestaduais de produtos que tiveram retenção antecipada
                        de ICMS por ST na UF do remetente. Repasse via Substituto Tributário.
                      </option>
                      <option value="61">[61] tributação monofásica sobre combustíveis cobrada anteriormente</option>
                      <option value="70">[70] tributada com redução de base de cálculo e com cobrança do ICMS por
                        substituição tributária
                      </option>
                      <option value="90">[90] outras (regime Normal)</option>
                      <option value="90_partilha">[90_partilha] outras (regime Normal). Operação interestadual para
                        consumidor final com partilha do ICMS devido na operação entre a UF de origem e a do
                        destinatário, ou a UF definida na legislação. (Ex. UF da concessionária de entrega do veículo)
                      </option>
                      <option value="101">[101] tributada pelo Simples Nacional com permissão de crédito</option>
                      <option value="102">[102] tributada pelo Simples Nacional sem permissão de crédito</option>
                      <option value="103">[103] isenção do ICMS no Simples Nacional para faixa de receita bruta</option>
                      <option value="201">[201] tributada pelo Simples Nacional com permissão de crédito e com cobrança
                        do ICMS por substituição tributária
                      </option>
                      <option value="202">[202] tributada pelo Simples Nacional sem permissão de crédito e com cobrança
                        do ICMS por substituição tributária
                      </option>
                      <option value="203">[203] isenção do ICMS nos Simples Nacional para faixa de receita bruta e com
                        cobrança do ICMS por substituição tributária
                      </option>
                      <option value="300">[300] imune</option>
                      <option value="400">[400] não tributada pelo Simples Nacional</option>
                      <option value="500">[500] ICMS cobrado anteriormente por substituição tributária (substituído) ou
                        por antecipação
                      </option>
                      <option value="900">[900] outras (regime Simples Nacional)</option>
                    </select>
                  </b-form-group>
                </div>


                <div class="col-md-6">
                  <b-form-group
                      class="mb-3"
                      label="Cód. Pis"
                      label-for="notaitem.cst_pis"
                  >
                    <select id="notaitem.cst_pis" v-model="notaitem.cst_pis" class="form-control" required>
                      <option value="01">[01] operação tributável: base de cálculo = valor da operação (alíquota normal
                        - cumulativo/não cumulativo)
                      </option>
                      <option value="02">[02] operação tributável: base de cálculo = valor da operação (alíquota
                        diferenciada)
                      </option>
                      <option value="03">[03] operação tributável: base de cálculo = quantidade vendida × alíquota por
                        unidade de produto
                      </option>
                      <option value="04">[04] operação tributável: tributação monofásica (alíquota zero)</option>
                      <option value="05">[05] operação tributável: substituição tributária</option>
                      <option value="06">[06] operação tributável: alíquota zero</option>
                      <option value="07">[07] operação isenta da contribuição</option>
                      <option value="08">[08] operação sem incidência da contribuição</option>
                      <option value="09">[09] operação com suspensão da contribuição</option>
                      <option value="49">[49] outras operações de saída</option>
                      <option value="50">[50] operação com direito a crédito: vinculada exclusivamente a receita
                        tributada no mercado interno
                      </option>
                      <option value="51">[51] operação com direito a crédito: vinculada exclusivamente a receita não
                        tributada no mercado interno
                      </option>
                      <option value="52">[52] operação com direito a crédito: vinculada exclusivamente a receita de
                        exportação
                      </option>
                      <option value="53">[53] operação com direito a crédito: vinculada a receitas tributadas e
                        não-tributadas no mercado interno
                      </option>
                      <option value="54">[54] operação com direito a crédito: vinculada a receitas tributadas no mercado
                        interno e de exportação
                      </option>
                      <option value="55">[55] operação com direito a crédito: vinculada a receitas não-tributadas no
                        mercado interno e de exportação
                      </option>
                      <option value="56">[56] operação com direito a crédito: vinculada a receitas tributadas e
                        não-tributadas no mercado interno e de exportação
                      </option>
                      <option value="60">[60] crédito presumido: operação de aquisição vinculada exclusivamente a
                        receita tributada no mercado interno
                      </option>
                      <option value="61">[61] crédito presumido: operação de aquisição vinculada exclusivamente a
                        receita não-tributada no mercado interno
                      </option>
                      <option value="62">[62] crédito presumido: operação de aquisição vinculada exclusivamente a
                        receita de exportação
                      </option>
                      <option value="63">[63] crédito presumido: operação de aquisição vinculada a receitas tributadas e
                        não-tributadas no mercado interno
                      </option>
                      <option value="64">[64] crédito presumido: operação de aquisição vinculada a receitas tributadas
                        no mercado interno e de exportação
                      </option>
                      <option value="65">[65] crédito presumido: operação de aquisição vinculada a receitas
                        não-tributadas no mercado interno e de exportação
                      </option>
                      <option value="66">[66] crédito presumido: operação de aquisição vinculada a receitas tributadas e
                        não-tributadas no mercado interno e de exportação
                      </option>
                      <option value="67">[67] crédito presumido: outras operações</option>
                      <option value="70">[70] operação de aquisição sem direito a crédito</option>
                      <option value="71">[71] operação de aquisição com isenção</option>
                      <option value="72">[72] operação de aquisição com suspensão</option>
                      <option value="73">[73] operação de aquisição a alíquota zero</option>
                      <option value="74">[74] operação de aquisição sem incidência da contribuição</option>
                      <option value="75">[75] operação de aquisição por substituição tributária</option>
                      <option value="98">[98] outras operações de entrada</option>
                      <option value="99">[99] outras operações</option>
                    </select>
                  </b-form-group>
                </div>


                <div class="col-md-6">
                  <b-form-group
                      class="mb-3"
                      label="Cód. Cofins"
                      label-for="notaitem.cst_cof"
                  >
                    <select id="notaitem.cst_cof" v-model="notaitem.cst_cof" class="form-control" required>
                      <option value="01">[01] operação tributável: base de cálculo = valor da operação (alíquota normal
                        - cumulativo/não cumulativo)
                      </option>
                      <option value="02">[02] operação tributável: base de cálculo = valor da operação (alíquota
                        diferenciada)
                      </option>
                      <option value="03">[03] operação tributável: base de cálculo = quantidade vendida × alíquota por
                        unidade de produto
                      </option>
                      <option value="04">[04] operação tributável: tributação monofásica (alíquota zero)</option>
                      <option value="05">[05] operação tributável: substituição tributária</option>
                      <option value="06">[06] operação tributável: alíquota zero</option>
                      <option value="07">[07] operação isenta da contribuição</option>
                      <option value="08">[08] operação sem incidência da contribuição</option>
                      <option value="09">[09] operação com suspensão da contribuição</option>
                      <option value="49">[49] outras operações de saída</option>
                      <option value="50">[50] operação com direito a crédito: vinculada exclusivamente a receita
                        tributada no mercado interno
                      </option>
                      <option value="51">[51] operação com direito a crédito: vinculada exclusivamente a receita não
                        tributada no mercado interno
                      </option>
                      <option value="52">[52] operação com direito a crédito: vinculada exclusivamente a receita de
                        exportação
                      </option>
                      <option value="53">[53] operação com direito a crédito: vinculada a receitas tributadas e
                        não-tributadas no mercado interno
                      </option>
                      <option value="54">[54] operação com direito a crédito: vinculada a receitas tributadas no mercado
                        interno e de exportação
                      </option>
                      <option value="55">[55] operação com direito a crédito: vinculada a receitas não-tributadas no
                        mercado interno e de exportação
                      </option>
                      <option value="56">[56] operação com direito a crédito: vinculada a receitas tributadas e
                        não-tributadas no mercado interno e de exportação
                      </option>
                      <option value="60">[60] crédito presumido: operação de aquisição vinculada exclusivamente a
                        receita tributada no mercado interno
                      </option>
                      <option value="61">[61] crédito presumido: operação de aquisição vinculada exclusivamente a
                        receita não-tributada no mercado interno
                      </option>
                      <option value="62">[62] crédito presumido: operação de aquisição vinculada exclusivamente a
                        receita de exportação
                      </option>
                      <option value="63">[63] crédito presumido: operação de aquisição vinculada a receitas tributadas e
                        não-tributadas no mercado interno
                      </option>
                      <option value="64">[64] crédito presumido: operação de aquisição vinculada a receitas tributadas
                        no mercado interno e de exportação
                      </option>
                      <option value="65">[65] crédito presumido: operação de aquisição vinculada a receitas
                        não-tributadas no mercado interno e de exportação
                      </option>
                      <option value="66">[66] crédito presumido: operação de aquisição vinculada a receitas tributadas e
                        não-tributadas no mercado interno e de exportação
                      </option>
                      <option value="67">[67] crédito presumido: outras operações</option>
                      <option value="70">[70] operação de aquisição sem direito a crédito</option>
                      <option value="71">[71] operação de aquisição com isenção</option>
                      <option value="72">[72] operação de aquisição com suspensão</option>
                      <option value="73">[73] operação de aquisição a alíquota zero</option>
                      <option value="74">[74] operação de aquisição sem incidência da contribuição</option>
                      <option value="75">[75] operação de aquisição por substituição tributária</option>
                      <option value="98">[98] outras operações de entrada</option>
                      <option value="99">[99] outras operações</option>
                    </select>
                  </b-form-group>
                </div>

                <div class="col-md-2">
                  <b-form-group
                      class="mb-3"
                      label="% Alíquota ICMS"
                      label-for="notaitem.picmsefet"
                  >
                    <b-form-input
                        id="notaitem.picmsefet"
                        type="text"
                        v-model="notaitem.picmsefet"
                        readonly
                    ></b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-2">
                  <b-form-group
                      class="mb-3"
                      label="% redução"
                      label-for="notaitem.predbcefet"
                  >
                    <b-form-input
                        id="notaitem.predbcefet"
                        type="text"
                        v-model="notaitem.predbcefet"
                        readonly
                    ></b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-2">
                  <b-form-group
                      class="mb-3"
                      label="Mod. Cálculo"
                      label-for="notaitem.modbc"
                  >
                    <b-form-input
                        id="notaitem.modbc"
                        type="text"
                        v-model="notaitem.modbc"
                        readonly
                    ></b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-2">
                  <b-form-group
                      class="mb-3"
                      label="Valor final ICMS"
                      label-for="notaitem.vicms"
                  >
                    <b-form-input
                        id="notaitem.vbc"
                        type="text"
                        v-model="notaitem.vicms"
                        readonly
                    ></b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-2">
                  <b-form-group
                      class="mb-3"
                      label="R$ Desconto"
                      label-for="notaitem.desconto"
                  >
                    <b-form-input
                        id="notaitem.desconto"
                        type="text"
                        v-model="notaitem.desconto"
                        readonly
                    ></b-form-input>
                  </b-form-group>
                </div>
                <hr>
              </div>
            </div>

            <br>
            <hr>
            <div class="row">
              <h4>Informações adicionais</h4>
              <div class="col-md-15">
                <b-form-group
                    class="mb-3"
                    label="Complemento"
                    label-for="nota_infadic.infcpl"
                >
                  <b-form-input
                      id="nota_infadic.infcpl"
                      type="text"
                      v-model="nota_infadic.infcpl"
                      class="custom-input"
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>

            <br><br>

            <div class="justify-content-center">
              <b-button variant="success" @click="updateNfe">Atualizar dados</b-button>
              <b-button variant="error" @click="showEspelhoNota = false">Fechar</b-button>
            </div>
          </b-form>
        </div>
      </div>
    </b-modal>

    <b-modal size="lg"
             v-model="showModalMovCompra"
             centered hide-footer>

      <div class="col-md-12">
        <div class="mb-3">
          <span>Selecionar compra feita</span>

          <multiselect id="inputCliente"
                       @search-change="pesqMovCompra"
                       @select="escolheuMovCompra"
                       v-model="ordemcompra"
                       placeholder="Pesquisar Compra"
                       :options="dtListPesqCompra"
                       :searchable="true"
                       label="nome"
                       track-by="nome"
                       value-prop="codigo">
            <template #option="slotProps">
              <div class="row">
                <a
                    v-b-tooltip.hover
                    placement="top"
                    title="Calcular redução de imposto"
                    @click="escolheuMovCompra(slotProps.option.id)">
                  <div>
                    <span class="text-primary">
                      {{ "Id: " + slotProps.option.id }}
                    </span>
                  </div>

                  <div
                      class="align-items-end text-end align-content-end">
                    {{ "Número da NFe de compra: " + slotProps.option.nnf }}
                  </div>
                </a>
              </div>
            </template>
          </multiselect>

        </div>
      </div>
    </b-modal>

    <b-modal
        v-model="modalHelpVbc"
        id="modal-center"
        centered
        title="Entendendo o valor do ICMS"
        title-class="font-20"
        class="bg-dark font-18"
        hide-footer
    >
      <p>
        O valor do ICMS apresentado é o final, ou seja aplicado aos valores de percentual de redução e a alíquota
        cadastrada
      </p>
    </b-modal>


    <b-modal size="xl" title="Cotação de Frete" v-model="showModalCotarFrete" centered hide-footer>
      <div class="col-md-12">
        <div class="row" v-if="loadingCotarFrete">
          <div class="col-12 text-center">
            <b-spinner type="grow"
                       class="m-6 mx-2"
                       variant="secondary"
                       role="status">
            </b-spinner>
            <b-spinner type="grow"
                       class="m-6 mx-2"
                       variant="secondary"
                       role="status">
            </b-spinner>
            <b-spinner type="grow"
                       class="m-6 mx-2"
                       variant="secondary"
                       role="status">
            </b-spinner>
          </div>
        </div>

        <div class="table-responsive" v-if="cotaFreteListData">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Ações</th>
              <th scope="col">TranspNome</th>
              <th scope="col" class="">Frete R$</th>
              <th scope="col" class="">Frete %</th>
              <th scope="col" class="">Frete KG</th>


              <th scope="col" class="text-end">PrazoDias</th>

              <th scope="col">TranspCNPJ</th>
              <th scope="col">TranspEmail</th>
              <th scope="col" class="text-end">Mov.Cot.ID</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in cotaFreteListData" :key="data.id">
              <td>
                <a href="javascript:void(0);"
                   v-b-tooltip.hover
                   class="action-icon text-info mx-2"
                   title="Escolher Transportadora"
                   @click="escolherFrete(data.WSOut_Frete_Val, data.WSOut_Transp_CNPJ, data.WSOut_MovCot_ID, data.WSOut_Prazo_Dias, data.WSOut_Transp_Nome, data.WSOut_Transp_Email)">
                  <i class="mdi mdi-check-outline font-size-18"></i>
                </a>
              </td>

              <td>
                {{ data.WSOut_Transp_Nome }}
              </td>

              <td class="text-end">
                <i class="bx bxs-dollar-circle font-size-18 bx-fade-right text-success" v-if="data.menorvalor"></i>
                {{ formatDecimal(data.WSOut_Frete_Val) }}
              </td>

              <td class="text-end">
                <i class="bx bxs-dollar-circle font-size-18 bx-fade-right text-success" v-if="data.menorvalor"></i>
                {{ formatDecimal((data.WSOut_Frete_Val / pedidoData.valorliq) * 100) }}
              </td>

              <td class="text-end">
                <i class="bx bxs-dollar-circle font-size-18 bx-fade-right text-success" v-if="data.menorvalor"></i>
                {{ formatDecimal((data.WSOut_Frete_Val / pedidoData.peso) * 100) }}
              </td>

              <td class="text-end">
                <i class="bx bxs-calendar font-size-18 bx-fade-right text-info" v-if="data.menorprazo"></i>
                {{ data.WSOut_Prazo_Dias }}
              </td>

              <td>
                {{ data.WSOut_Transp_CNPJ }}
              </td>
              <td>
                {{ data.WSOut_Transp_Email }}
              </td>
              <td class="text-end">
                {{ data.WSOut_MovCot_ID }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <!-- <div class="text-end mt-5">
          <b-button variant="light" @click="showModalCotarFrete = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="showModalCotarFrete = false">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div> -->
      </div>
    </b-modal>

    <b-modal
        size="lg"
        title="Alterar Observações"
        v-model="showModalObs"
        centered
        hide-footer
    >
      <div class="col-md-12">
        <div class="mb-3">
          <span class="text-info">
            <strong>Atenção: </strong>
            As observações serão concatenadas resultando nas observações da nota fiscal.</span>
        </div>

        <div class="mb-3">
          <label for="obs">Observações do Pedido</label>
          <textarea
              id="obs"
              v-model="pedidoData.obs"
              type="text"
              rows="3"
              class="form-control"
              placeholder="Observações do Pedido"
          />
        </div>

        <div class="mb-5">
          <label for="obsnf">Observações Fixas</label>
          <div class="border p-2 rounded">
            <span class="ms-1 text-muted" v-if="empresaData?.obsadicionais">{{`${this.empresaData?.obsadicionais}`}} <br></span>
          </div>
        </div>

        <div class="mb-2">
          <label for="obsnf">Observações da Nota Fiscal</label>
          <div class="border p-2 rounded">
            <span class="ms-1 text-muted" v-if="pedidoData?.obs">{{`${this.pedidoData?.obs}`}} <br></span>
            <span class="ms-1 text-muted" v-if="empresaData?.obsadicionais">{{`${this.empresaData?.obsadicionais}`}} <br></span>
          </div>
<!--          <textarea
              id="obsnf"
              v-model="pedidoData.obsnf"
              type="text"
              rows="3"
              class="form-control"
              placeholder="Observações da Nota Fiscal"
          />-->
        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalObs = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button
              type="submit"
              variant="success"
              class="ms-1"
              @click="confirmarObs"
          >
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal title="Volumes da Cotação"
             v-model="showModalVolume"
             size="xl"
             centered hide-footer
             @hidden="showModalVolume = false">

      <div class="col-md-12">
        <div class="mb-3">
          <div class="row">
            <div class="row">
              <div class="col-md-2">
                <div class="mb-3">
                  <label >ID</label>
                </div>
              </div>
              <div class="col-md-2">
                <div class="mb-3">
                  <label>Largura (cm)</label>
                </div>
              </div>
              <div class="col-md-2">
                <div class="mb-3">
                  <label>Altura (cm)</label>
                </div>
              </div>
              <div class="col-md-2">
                <div class="mb-3">
                  <label>Compr.(cm)</label>
                </div>
              </div>
              <div class="col-md-2">
                <div class="mb-3">
                  <label>Quantidade</label>
                </div>
              </div>
              <div class="col-md-2">
                <div class="mb-3">
                  <label>Peso Cubado</label>
                </div>
              </div>
              <div class="col-md-1 text-end">
              </div>
            </div>
          </div>

          <div
              v-for="(field, index) in cotaFrtVolumes"
              :key="field.id"
              class="row">
            <div class="col-md-1 text-end">
              <input
                  id="id"
                  v-model="field.id"
                  type="number"
                  class="form-control text-end"
                  placeholder="ID"
                  :disabled="true"/>
            </div>

            <div class="col-md-2 text-end">
              <input
                  id="largura"
                  v-model="field.largura"
                  type="number"
                  class="form-control text-end"
                  placeholder="Largura (cm)"
                  :class="{'is-invalid': submittedVolume && !field.largura}"/>
              <div v-if="submittedVolume && !field.largura"
                   class="invalid-feedback">
                <span>Campo obrigatório.</span>
              </div>
            </div>

            <div class="col-md-2 text-end">
              <input
                  id="altura"
                  v-model="field.altura"
                  type="number"
                  class="form-control text-end"
                  placeholder="Altura (cm)"
                  :class="{'is-invalid': submittedVolume && !field.altura}"/>
              <div v-if="submittedVolume && !field.altura"
                   class="invalid-feedback">
                <span>Campo obrigatório.</span>
              </div>
            </div>

            <div class="col-md-2 text-end">
              <input
                  id="comprimento"
                  v-model="field.comprim"
                  type="number"
                  class="form-control text-end"
                  placeholder="Comprimento (cm)"
                  :class="{'is-invalid': submittedVolume && !field.comprim}"/>
              <div v-if="submittedVolume && !field.comprim"
                   class="invalid-feedback">
                <span>Campo obrigatório.</span>
              </div>
            </div>

            <div class="col-md-2 text-end">
              <input
                  id="quant"
                  v-model="field.quant"
                  type="number"
                  class="form-control text-end"
                  placeholder="Quantidade"
                  :class="{'is-invalid': submittedVolume && !field.quant}"/>
              <div v-if="submittedVolume && !field.quant"
                   class="invalid-feedback">
                <span>Campo obrigatório.</span>
              </div>
            </div>

            <div class="col-md-2 text-end">
              <input
                  id="pesovol"
                  v-model="field.pesocub"
                  type="number"
                  class="form-control text-end"
                  placeholder="Peso"
                  :class="{'is-invalid': submittedVolume && !field.pesocub}"/>
              <div v-if="submittedVolume && !field.pesocuba"
                   class="invalid-feedback">
                <span>Campo obrigatório.</span>
              </div>
            </div>

            <div class="col-md-1 text-end">
              <div class="button-items">
                <b-button variant="outline-danger" @click="deletarVol(index)">
                  <i class="mdi mdi-trash-can d-block font-size-16"></i>
                </b-button>

              </div>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-md-3 text-end">
              <b-button variant="outline-info" @click="addVolume">
                <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                Novo Volume
              </b-button>
            </div>
          </div>
        </div>
      </div>

      <div >
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalVolume = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confVolume">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar Alterações
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal size="lg"
      :title="pedItemData.id != null ? `Editar Item do Pedido (${idData})` : 'Criar Novo Item no Pedido'"
      v-model="showModalPedItem" hide-footer>

      <div class="col-md-12">
        <div class="mb-3">
          <span>Selecionar Novo Produto</span>
          <multiselect id="prodorctoitem" ref="focusThis" @search-change="pesqPedItem" @select="escolheuPedItem"
            v-model="pedItemData.produto" placeholder="Pesquisar novo produto" :options="dtlistPesqPedItem"
            :searchable="true" label="descricao" class="multiselect-size" track-by="descrcodigo" value-prop="codigo">
            <template #option="slotProps" v-if="dtlistPesqPedItem">
              <div class="row" style="min-width: 100%;">

                <div style="min-width: 100%;">
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4">
                    {{ slotProps.option.unidade }}
                  </span>
                  <span class="float-end text-warning">
                    R$ {{ formatDecimal(slotProps.option.preco) }}
                  </span>
                </div>

                <div class="col-12">
                  <span class="mt-5 font-size-15">
                    {{ slotProps.option.descricao }}
                  </span>
                  <span class="float-end">
                    <!--                    R$ {{ formatDecimal(slotProps.option.preco) }}-->
                  </span>
                </div>
                <div class="align-items-end text-end align-content-end float-end">
                  <div v-if="!slotProps.option.imgSTrat" class="avatar-xs">
                    <span class="avatar-title rounded-circle">{{ slotProps.option.id }}</span>
                  </div>
                  <div v-if="slotProps.option.imgSTrat">
                    <img class="rounded-circle avatar-xs" :src="slotProps.option.img1" alt />
                  </div>

                  <span class="float-end ">
                    <span v-if="slotProps.option.saldo > 0"
                      class="avatar-title rounded-circle bg-success avatar-xs p-1">
                      <span class="">{{ formatInteger(slotProps.option.saldo) }}</span>
                    </span>

                    <span v-else class="avatar-title rounded-circle bg-danger avatar-xs p-1">
                      <span class="">{{ formatDecimal(slotProps.option.preco) }}</span>
                    </span>

                  </span>
                </div>


              </div>
            </template>
          </multiselect>
        </div>
      </div>
      <div class="row" v-if="loadingPedItem">
        <div class="col-12 text-center">
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
        </div>
      </div>

      <div v-if="!loadingPedItem && pedItemData && pedItemData.descprod">
        <router-link :to="`/produto/editar/${pedItemData.produto_id}`" target="_blank">
          <div class="row">
            <div class="col-lg-6">
              <div class="card mini-stats-wid">
                <div class="card-body" style="min-height: 160px;">
                  <div class="d-flex flex-wrap">

                    <div class="me-2">
                      <p class="text-muted mb-2">{{ pedItemData.descprod }}</p>
                      <h5 class="mb-0">saldo: {{ formatInteger(pedItemData.saldo) }} ({{ pedItemData.und }})</h5>
                    </div>

                    <h1>IMG2 {{ pedItemData.img1 }}</h1>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-sm ms-auto" v-if="!pedItemData.imgSTrat">
                        <div class="avatar-title bg-light rounded-circle text-primary font-size-20">
                          <i class="bx bx-camera-off"></i>
                        </div>
                      </div>

                      <div class="avatar-sm ms-auto" v-if="pedItemData.imgSTrat">
                        <div class="avatar-title bg-light rounded-circle text-primary font-size-20">
                          <img class="rounded-circle avatar-xs" :src="pedItemData.imgSTrat" alt />
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="card mini-stats-wid">
                <div class="card-body" style="min-height: 155px;">
                  <div class="d-flex flex-wrap">
                    <div class="me-2">
                      <span class="text-muted mb-2">Código: </span> <span class="text-info"> {{ pedItemData.produto }}
                      </span>
                    </div>
                    <div class="">
                      <p class="text-muted mb-2">Preço de Tabela (Bruto)</p>
                      <h5 class="mb-0 mt-3">R$ {{ formatDecimal(pedItemData.vlrunitbrt) }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-light rounded-circle text-primary font-size-20">
                        <i class="bx bx-money"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </router-link>



        <form class="needs-validation" @submit.prevent="confPedItem">
          <div class="row">

            <div class="col-md-6">
              <div class="mb-3">
                <label for="vlrunitliq">Valor Unitário</label>
                <input id="vlrunitliq" v-model="pedItemData.vlrunitliq" type="number" class="form-control text-end"
                  placeholder="Valor unitário líquido"
                  :class="{ 'is-invalid': submitPedItem && v$.pedItemData.vlrunitliq.$error, }" />
                <div v-if="submitPedItem && v$.pedItemData.vlrunitliq.$error" class="invalid-feedback">
                  <span v-if="v$.pedItemData.vlrunitliq.required.$message">{{
                    v$.pedItemData.vlrunitliq.required.$message }}</span>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="mb-3">
                <label for="qtd">Quantidade</label>
                <input id="qtd" v-model="pedItemData.qtd" type="number" class="form-control text-end"
                  placeholder="Quantidade" :class="{ 'is-invalid': submitPedItem && v$.pedItemData.qtd.$error, }" />
                <div v-if="submitPedItem && v$.pedItemData.qtd.$error" class="invalid-feedback">
                  <span v-if="v$.pedItemData.qtd.required.$message">{{ v$.pedItemData.qtd.required.$message
                    }}</span>
                </div>
              </div>
            </div>


            <div class="col-md-4">
              <div class="mb-3">
                <label for="lote">Lotes</label>
                <multiselect id="lotes"
                             @search-change="pesqLotes"
                             v-model="pedItemData.lote"
                             placeholder="Selecionar lotes"
                             :options="dtListLotes"
                             :searchable="true"
                             :mode="'tags'"
                             label="lote"
                             track-by="lote"
                             value-prop="lote">
                  <template #option="slotProps">
                    <div class="row">
                      <div class="mt-2 font-size-20">{{ slotProps.option.lote }}</div>
                    </div>
                  </template>
                </multiselect>
              </div>
            </div>
          </div>
        </form>



        <div class="row text-end" v-if="messageValidacaoItem !== ''">
          <div class="col-md-12">
            <span class="text-danger"> {{ messageValidacaoItem }} * </span>
          </div>
        </div>


        <div class="row">
          <div class="text-end mt-5">
            <b-button variant="light" @click="showModalPedItem = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Cancelar
            </b-button>
            <b-button variant="success" class="ms-1" @click="confPedItem" :disabled="messageValidacaoItem !== ''">
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal title="Detalhes Natureza operação" v-model="showModalNatureza" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <span>Selecionar Natureza da Operação</span>
          <multiselect
            id="tiponatureza"
            @search-change="pesqNatureza"
            @click="escolheuNatureza"
            v-model="pedidoData.tipo"
            placeholder="Pesquisar Natureza da operação"
            :options="dtlistPesqNatureza"
            :searchable="true"
            label="descricao"
            track-by="descricao"
            value-prop="id">

            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-muted font-size-14">
                    CFOP: {{ slotProps.option.cfopicms ?? 'Sem Cadastrado!' }}
                  </span>
                </div>

                <span class="mx-4"></span>

                <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>

                <span class="mx-4"></span>

                <div class="align-items-end text-end align-content-end">
                  {{ formatDateTime(slotProps.option.created_at) }}
                </div>
              </div>
            </template>
          </multiselect>
        </div>
      </div>

      <div class="row" v-if="loadingPedTipo">
        <div class="col-12 text-center">
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
        </div>
      </div>

      <div class="text-end mt-5">
          <b-button variant="light" @click="showModalNatureza = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button
            variant="success"
            class="ms-1"
            @click="showModalNatureza = false"
          >
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
    </b-modal>

    <b-modal title="Editar Dados Financeiros" v-model="showModalFinanceiroData" centered hide-footer>
      <div class="row mt-3">
        <div class="col-md-6">
          <div class="mb-3">
            <label for="condpgto">Condição de Pagamento</label>
            <multiselect id="condpgto"
                         @search-change="pesqCondPgto"
                         @select="escolheuCondPgto"
                         v-model="pedidoData.condpgto"
                         placeholder="Pesquisar condição de pagamento"
                         :options="dtListPesqCondPgto"
                         :searchable="true"
                         label="descricao"
                         class="multiselect-size"
                         track-by="codigo"
                         value-prop="codigo">
              <template #option="slotProps">
                <div class="row">
                  <div>
                    <span class="text-info">
                      {{ slotProps.option.codigo }}
                    </span>
                    <span class="ms-2" >
                      {{ slotProps.option.descricao }}
                    </span>
                  </div>
                </div>
              </template>
            </multiselect>
          </div>
        </div>


        <div class="col-md-6">
          <div class="mb-3">
            <label for="formapgto">Forma de Pagamento</label>
            <multiselect id="formapgto"
                         @search-change="pesqFormaPgto"
                         @select="escolheuFormaPgto"
                         v-model="pedidoData.formapgto"
                         placeholder="Pesquisar forma de pagamento"
                         :options="dtListPesqFormaPgto"
                         :searchable="true"
                         label="descricao"
                         class="multiselect-size"
                         track-by="codigo"
                         value-prop="codigo">
              <template #option="slotProps">
                <div class="row">
                  <div>
                    <span class="text-info">
                      {{ slotProps.option.codigo }}
                    </span>
                    <span class="ms-2" >
                      {{ slotProps.option.descricao }}
                    </span>
                  </div>
                </div>
              </template>
            </multiselect>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="banco">Instituição bancária</label>
            <multiselect id="inputFinConta"
                         @search-change="pesqConta"
                         @select="escolheuConta"
                         v-model="pedidoData.banco_id"
                         placeholder="Selecione a Inst. Bancária"
                         :options="dtListPesqConta"
                         :searchable="true"
                         label="descricao"
                         class="multiselect-size"
                         track-by="id"
                         value-prop="id">
              <template #option="slotProps">
                <div class="row">
                  <div>
                    <span class="text-info">
                      {{ slotProps.option.id }}
                    </span>
                    <span class="font-size-10 mx-1 me-4">
                       (banco: {{ slotProps.option.banco }})
                    </span>
                    <span class="" >
                      {{ slotProps.option.descricao }}
                    </span>
                  </div>
                </div>
              </template>
            </multiselect>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <div class="mb-4 align-items-end align-content-start float-start mx-4">
              <label for="consutil">Considerar apenas dias úteis</label>
              <b-form-checkbox switch size="lg" v-model="pedidoData.consutil">
                {{ pedidoData.consutil === false ? 'Desativado' : 'Ativado' }}
              </b-form-checkbox>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="loadingFinanc">
        <div class="col-12 text-center">
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
        </div>
      </div>

      <div v-if="!loadingFinanc && pedidoData">
        <div class="row mt-2">
          <h6 class="mb-2 col-md-12">Condição de Pagamento Atual:</h6>

          <div class="row">

            <div class="d-flex col-sm-6 mt-2">
              <h6 class="">Forma Pgto:
                <span class="text-muted ms-2" style="">{{ pedidoData?.formapgto}}</span>
                <span class="text-muted ms-1" v-if="formaPgtoData"> ( {{ formaPgtoData?.descricao }} )</span>
              </h6>
            </div>

            <div class="d-flex col-sm-6 mt-2">
              <h6 class="">Banco:
                <span class="text-muted ms-2" style="">{{ pedidoData?.banco_id}}</span>
                <span class="text-muted ms-1" v-if="contaData">
                        ( {{ contaData?.banco}} - {{ contaData?.descricao}} )
                      </span>
              </h6>
            </div>

            <div class="d-flex col-sm-6">
              <h6 class="">Cond. Pgto:
                <span class="text-muted ms-2">{{ pedidoData?.condpgto }}</span>
                <span class="text-muted ms-1" v-if="condPgtoData"> ( {{ condPgtoData?.descricao }} )</span>
              </h6>
            </div>

            <div class="d-flex col-sm-6">
              <h6 class="">Cons. dia útil::
                <span class="text-muted ms-2" style="">{{ pedidoData?.consutil}}</span>
              </h6>
            </div>
          </div>
        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalFinanceiroData = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarFinanceiro">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
        v-model="showModalDadosVolumes"
        id="modal-xl"
        size="xl"
        title="Dados de Wmsos Volumes"
        title-class="font-18"
        hide-footer
    >
      <div class="table-responsive">
        <table class="table mb-0">
          <thead class="table-light">
            <tr>
              <th class="text-center">Cod. Etiqueta</th>
              <th class="text-center">Qtd</th>
              <th class="text-center">Peso</th>
              <th class="text-center">Dt. Criação</th>
            </tr>
          </thead>
          <tbody>
              <tr v-for="data in dtListWmsOsVolumes" :key="data.id">
                <td>{{data.etiqueta}}</td>
                <td class="text-right">{{formatDecimal(data.qtd)}}</td>
                <td>{{formatDecimal(data.peso)}}</td>
                <td>{{formatDateTime(data.created_at)}}</td>
              </tr>
          </tbody>
        </table>
      </div>
    </b-modal>

    <b-modal title="Editar Valor Frete" v-model="showModalEditaVlrf" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="vlrfrt">
            Valor de Frete:
          </label><br>
          <input
              id="vlrfrt"
              type="number"
              v-model="pedidoData.valorfrete"
              class="text-muted"
              placeholder="Valor do Frete"
          />
        </div>
      </div>

      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalEditaVlrf = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button
            variant="success"
            class="ms-1"
            @click="confirmaEditvlrfrt"
        >
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>

    <b-modal title="Selecionar Transportadora" v-model="showModalEditaTransp" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="vlrfrt">
            Transportadora:
          </label><br>
          <div class="col-md-12">
            <div class="mb-3">
              <span>Selecionar Nova Transportadora</span>

              <multiselect
                  id="transp"
                  @search-change="pesqTransp"
                  @select="escolheuTransp"
                  v-model="TranspSelecionado"
                  placeholder="Pesquisar transportadora"
                  :options="dtListPesqTransp"
                  :searchable="true"
                  label="nome"
                  track-by="codigo"
                  value-prop="codigo"
              >
                <template #option="slotProps">
                  <div class="row">
                    <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                      <span class="mx-4"> </span>
                    </div>
                    <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                    <span class="mx-4"> </span>
                    <span class="mx-4"> </span>
                    <div class="align-items-end text-end align-content-end">
                      {{ formatDateTime(slotProps.option.created_at) }}
                    </div>
                  </div>
                </template>
              </multiselect>
            </div>
          </div>
        </div>
      </div>

      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalEditaTransp = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button
            variant="success"
            class="ms-1"
            @click="confirmaEditTransp"
        >
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>
  </Layout>
</template>

<style>
.custom-input {
  word-wrap: break-word;
  height: 30px;
}
.white-background {
  background-color: white;
}
</style>
